/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('xoil.pages', [
    'ui.router',

    'xoil.pages.dashboard',
    'xoil.pages.sales',
    'xoil.pages.attendants',
    'xoil.pages.station',
    'xoil.pages.companies',
    
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/dashboard');

/*    baSidebarServiceProvider.addStaticItem({
      title: 'Pages',
      icon: 'ion-document',
      subMenu: [{
        title: 'Sign In',
        fixedHref: 'auth.html',
        blank: true
      }, {
        title: 'Sign Up',
        fixedHref: 'reg.html',
        blank: true
      }, {
        title: 'User Profile',
        stateRef: 'profile'
      }, {
        title: '404 Page',
        fixedHref: '404.html',
        blank: true
      }]
    });*/

/*    baSidebarServiceProvider.addStaticItem({
      title: 'Menu Level 1',
      icon: 'ion-ios-more',
      subMenu: [{
        title: 'Menu Level 1.1',
        disabled: true
      }, {
        title: 'Menu Level 1.2',
        subMenu: [{
          title: 'Menu Level 1.2.1',
          disabled: true
        }]
      }]
    });*/

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('xoil.components', [
    //'BlurAdmin.components.fromDateTimeToDateTime',
    
  ]);

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author Patrick Agius
 * created on 2018-09-03
 */
(function () {
  'use strict';

  angular.module('xoil.services', []);


})();

(function () {
  'use strict';

  angular.module('xoil.pages.attendants', [
    'xoil.pages.attendants.list',
    'xoil.pages.attendants.create',
    'xoil.pages.attendants.details',

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('attendants', {
          url: '/attendants',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Attendants',
          sidebarMeta: {
            icon: 'ion-person',
            order: 200,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies', [
    'xoil.pages.companies.list',
    'xoil.pages.companies.create',
    'xoil.pages.companies.details',
    'xoil.pages.companies.ibuttonsearch',
    'xoil.pages.companies.reports',
    'xoil.pages.companies.accountcreate',
    'xoil.pages.companies.accountdetails',
    'xoil.pages.companies.accountslist',
    'xoil.pages.companies.postingslist',
    'xoil.pages.companies.postingdetails',
    'xoil.pages.companies.postpaypostingcreate',
    //'xoil.pages.companies.prepaypostingcreate',

     

  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('companies', {
          url: '/companies',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Companies',
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 300,
          },
        });
  }

})();

(function () {
    'use strict';

    angular.module('xoil.pages.dashboard', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
        .state('dashboard', {
            url: '/dashboard',
            templateUrl: 'app/pages/dashboard/dashboard.html',
            title: 'Dashboard',
            sidebarMeta: {
                icon: 'ion-android-home',
                order: 1,
            },
        });
    }

})();
(function () {
  'use strict';

  angular.module('xoil.pages.sales', [
    'xoil.pages.sales.total',
    'xoil.pages.sales.button',
    'xoil.pages.sales.cash',
    'xoil.pages.sales.card',
    //'xoil.pages.sales.cardbatches',
    'xoil.pages.sales.manual',
    'xoil.pages.sales.tagging',
    'xoil.pages.sales.kiosk',
    //'xoil.pages.sales.devices',
    'xoil.pages.sales.tank',
    'xoil.pages.sales.fueldaily',
    'xoil.pages.sales.fuelmonthly',
    'xoil.pages.sales.fuelyearly',
    'xoil.pages.sales.pump',
    'xoil.pages.sales.cashinserted',
    'xoil.pages.sales.newrefund',
    'xoil.pages.sales.refunds',
    'xoil.pages.sales.refundsaudit',

  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('sales', {
          url: '/sales',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Sales',
          sidebarMeta: {
            icon: 'ion-ios-cart',
            order: 100,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station', [
    'xoil.pages.station.details',
    'xoil.pages.station.receiptsfooters',
    'xoil.pages.station.receiptsfootersdetails',
    'xoil.pages.station.receiptsfooterscreate',
    'xoil.pages.station.tanks',
    'xoil.pages.station.tankscalibrate',
    'xoil.pages.station.pumps',
    'xoil.pages.station.pumpscalibrate',
    'xoil.pages.station.fuelrates',
    'xoil.pages.station.fuelpurchases',
    'xoil.pages.station.fuelpurchaseCreate',
    'xoil.pages.station.departments',
    'xoil.pages.station.departmentdetails',
    'xoil.pages.station.departmentcreate',
    'xoil.pages.station.suppliers',
    'xoil.pages.station.supplierdetails',
    'xoil.pages.station.suppliercreate',
    
    // 'xoil.pages.station.backups',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('station', {
          url: '/station',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Station',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function () {
  'use strict';

  angular.module('xoil.pages.attendants.create', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('attendants.create', {
            url: '/details/create',
            templateUrl: 'app/pages/attendants/create/template.html',
            controller: "attendantsCreateCtrl",
            title: 'New Attendant',
            sidebarMeta: {
                order: 50,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.attendants.list', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('attendants.list', {
            url: '/list',
            templateUrl: 'app/pages/attendants/list/template.html',
            controller: "attendantsListCtrl",
            //controllerAs: "",
            title: 'Attendants List',
            sidebarMeta: {
                order: 30,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.accountdetails', [])
    .config(routeConfig);

  /** @ngInject */

    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyAccountDetails', {
            url: '/company/:companyId/accounts/:accountId/details',
            templateUrl: 'app/pages/companies/account-details/template.html',
            controller: "companiesAccountDetailsCtrl",
            //controllerAs: "",
            title: 'Account Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }


    // function routeConfig($stateProvider,$urlRouterProvider) {
    //     $stateProvider
    //     .state('companies.accountdetails', {
    //         url: '/account-details',
    //         templateUrl: 'app/pages/companies/account-details/template.html',
    //         controller: "companiesAccountDetailsCtrl",
    //         //controllerAs: "",
    //         title: 'Account Details',
    //         // sidebarMeta: {
    //         //     order: 10,
    //         // }
    //     });
    // }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.accountcreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companiesAccountCreate', {
            url: '/company/:companyId/account-create',
            templateUrl: 'app/pages/companies/account-create/template.html',
            controller: "companiesAccountCreateCtrl",
            //controllerAs: "",
            title: 'Account Create',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.attendants.details', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('attendants.details', {
            url: '/details/:attendantId',
            templateUrl: 'app/pages/attendants/details/template.html',
            controller: "attendantsDetailsCtrl",
            title: 'Attendant Details',
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.accountslist', [])
    .config(routeConfig);

  /** @ngInject */

    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyAccounts', {
            url: '/company/:companyId/accounts',
            templateUrl: 'app/pages/companies/accounts-list/template.html',
            controller: "companiesAccountsListCtrl",
            //controllerAs: "",
            title: 'List of Accounts',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }


})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.details', [])
    .config(routeConfig);

  /** @ngInject */

    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyDetails', {
            url: '/company/:companyId/details',
            templateUrl: 'app/pages/companies/details/template.html',
            controller: "companiesDetailsCtrl",
            //controllerAs: "",
            title: 'Company Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

    // function routeConfig($stateProvider,$urlRouterProvider) {
    //     $stateProvider
    //     .state('companies.details', {
    //         url: '/details/:companyId',
    //         templateUrl: 'app/pages/companies/details/template.html',
    //         controller: "companiesDetailsCtrl",
    //         //controllerAs: "",
    //         title: 'Company Details',
    //         // sidebarMeta: {
    //         //     order: 10,
    //         // }
    //     });
    // }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.create', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companies.create', {
            url: '/details/create',
            templateUrl: 'app/pages/companies/create/template.html',
            controller: "companiesCreateCtrl",
            //controllerAs: "",
            title: 'New Company',
            sidebarMeta: {
                order: 20,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.ibuttonsearch', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companies.ibutton-search', {
            url: '/ibutton-search',
            templateUrl: 'app/pages/companies/ibutton-search/template.html',
            controller: "companiesIButtonSearchCtrl",
            //controllerAs: "",
            title: 'iButton Search',
            sidebarMeta: {
                order: 30,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.list', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companies.list', {
            url: '/',
            templateUrl: 'app/pages/companies/list/template.html',
            controller: "companiesListCtrl",
            //controllerAs: "",
            title: 'Companies List',
            sidebarMeta: {
                order: 20,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.postpaypostingcreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyPostPayPostingCreate', {
            url: '/company/:companyId/post-pay-posting-create',
            templateUrl: 'app/pages/companies/posting-post-pay-create/template.html',
            controller: "companiesPostPayPostingCreateCtrl",
            //controllerAs: "",
            title: 'New Posting', // 'New Post-Pay Posting',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.prepaypostingcreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyPrePayPostingCreate', {
            url: '/company/:companyId/pre-pay-posting-create',
            templateUrl: 'app/pages/companies/posting-pre-pay-create/template.html',
            controller: "companiesPrePayPostingCreateCtrl",
            //controllerAs: "",
            title: 'New Pre-Pay Posting',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.postingslist', [])
    .config(routeConfig);

  /** @ngInject */

    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyPostings', {
            url: '/company/:companyId/postings',
            templateUrl: 'app/pages/companies/postings-list/template.html',
            controller: "companiesPostingsListCtrl",
            //controllerAs: "",
            title: 'Postings',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

    

    // function routeConfig($stateProvider,$urlRouterProvider) {
    //     $stateProvider
    //     .state('companies.accounts', {
    //         url: '/accounts/:companyId',
    //         templateUrl: 'app/pages/companies/accounts-list/template.html',
    //         controller: "companiesAccountsListCtrl",
    //         //controllerAs: "",
    //         title: 'List of Accounts',
    //         // sidebarMeta: {
    //         //     order: 10,
    //         // }
    //     });
    // }


})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.postingdetails', [])
    .config(routeConfig);

  /** @ngInject */

    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companyPostingDetails', {
            url: '/company/:companyId/postings/:postingId/details',
            templateUrl: 'app/pages/companies/posting-details/template.html',
            controller: "companiesPostingDetailsCtrl",
            //controllerAs: "",
            title: 'Posting Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }


    // function routeConfig($stateProvider,$urlRouterProvider) {
    //     $stateProvider
    //     .state('companies.accountdetails', {
    //         url: '/account-details',
    //         templateUrl: 'app/pages/companies/account-details/template.html',
    //         controller: "companiesAccountDetailsCtrl",
    //         //controllerAs: "",
    //         title: 'Account Details',
    //         // sidebarMeta: {
    //         //     order: 10,
    //         // }
    //     });
    // }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.companies.reports', ['ui.select'])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('companies.reports', {
            url: '/reports',
            templateUrl: 'app/pages/companies/reports/template.html',
            controller: "companiesReportsCtrl",
            //controllerAs: "",
            title: 'Reports',
            sidebarMeta: {
                order: 40,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.card', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.card', {
            url: '/card',
            templateUrl: 'app/pages/sales/card/template.html',
            controller: "salesCardCtrl",
            //controllerAs: "",
            title: 'Card Sales',
            sidebarMeta: {
                order: 30,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages')
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('changepassword', {
            url: '/change-password',
            templateUrl: 'app/pages/login/change-password/template.html',
            controller: "changePasswordCtrl",
            //controllerAs: "",
            title: 'Change Password',
            // sidebarMeta: {
            //     order: 40,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.button', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.button', {
            url: '/button',
            templateUrl: 'app/pages/sales/button/template.html',
            controller: "salesButtonCtrl",
            //controllerAs: "",
            title: 'Button Sales',
            sidebarMeta: {
                order: 15,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.cardbatches', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.cardbatches', {
            url: '/card-batches',
            templateUrl: 'app/pages/sales/card-batches/template.html',
            controller: "salesCardBatchesCtrl",
            //controllerAs: "",
            title: 'Card Sales Batches',
            sidebarMeta: {
                order: 40,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.fueldaily', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.fueldaily', {
            url: '/fueldaily',
            templateUrl: 'app/pages/sales/fuel-daily/template.html',
            controller: "salesFuelDailyCtrl",
            //controllerAs: "",
            title: 'Fuel (Daily)',
            sidebarMeta: {
                order: 100,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.cash', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.cash', {
            url: '/cash',
            templateUrl: 'app/pages/sales/cash/template.html',
            controller: "salesCashCtrl",
            //controllerAs: "",
            title: 'Cash Sales',
            sidebarMeta: {
                order: 20,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.fuelmonthly', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.fuelmonthly', {
            url: '/fuelmonthly',
            templateUrl: 'app/pages/sales/fuel-monthly/template.html',
            controller: "salesFuelMonthlyCtrl",
            //controllerAs: "",
            title: 'Fuel (Monthly)',
            sidebarMeta: {
                order: 110,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.cashinserted', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.cashinserted', {
            url: '/cashinserted',
            templateUrl: 'app/pages/sales/cash-inserted/template.html',
            controller: "salesCashInsertedCtrl",
            //controllerAs: "",
            title: 'Cash Inserted',
            sidebarMeta: {
                order: 25,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.fuelyearly', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.fuelyearly', {
            url: '/fuelyearly',
            templateUrl: 'app/pages/sales/fuel-yearly/template.html',
            controller: "salesFuelYearlyCtrl",
            //controllerAs: "",
            title: 'Fuel (Yearly)',
            sidebarMeta: {
                order: 120,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.kiosk', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.kiosk', {
            url: '/kiosk',
            templateUrl: 'app/pages/sales/kiosk/template.html',
            controller: "salesKioskCtrl",
            //controllerAs: "",
            title: 'Kiosk Sales',
            sidebarMeta: {
                order: 70,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.manual', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.manual', {
            url: '/manual',
            templateUrl: 'app/pages/sales/manual/template.html',
            controller: "salesManualCtrl",
            //controllerAs: "",
            title: 'Manual Sales',
            sidebarMeta: {
                order: 50,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.newrefund', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.newrefund', {
            url: '/new-refund',
            templateUrl: 'app/pages/sales/refund-new/template.html',
            controller: "salesRefundNewCtrl",
            //controllerAs: "",
            title: 'New Refund',
            sidebarMeta: {
                order: 160,
            }
        })
        .state('sales.newrefundvrn', {
            url: '/new-refund/:date/:dayReceiptId/:vrn',
            templateUrl: 'app/pages/sales/refund-new/template.html',
            controller: "salesRefundNewCtrl",
            title: 'New Refund',
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.pump', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.pump', {
            url: '/pump',
            templateUrl: 'app/pages/sales/pump/template.html',
            controller: "salesPumpCtrl",
            //controllerAs: "",
            title: 'Pump Sales',
            sidebarMeta: {
                order: 130,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.refunds', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.refunds', {
            url: '/refunds',
            templateUrl: 'app/pages/sales/refunds/template.html',
            controller: "salesRefundsCtrl",
            //controllerAs: "",
            title: 'Refunds',
            sidebarMeta: {
                order: 160,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.refundsaudit', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.refundsaudit', {
            url: '/refundsaudit',
            templateUrl: 'app/pages/sales/refunds-audit/template.html',
            controller: "salesRefundsAuditCtrl",
            //controllerAs: "",
            title: 'Refunds Audit',
            sidebarMeta: {
                order: 170,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.tagging', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.tagging', {
            url: '/tagging',
            templateUrl: 'app/pages/sales/tagging/template.html',
            controller: "salesTaggingCtrl",
            //controllerAs: "",
            title: 'Tagging Sales',
            sidebarMeta: {
                order: 60,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.tank', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.tank', {
            url: '/tank',
            templateUrl: 'app/pages/sales/tank/template.html',
            controller: "salesTankCtrl",
            //controllerAs: "",
            title: 'Tank Sales',
            sidebarMeta: {
                order: 90,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.departments', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.departments', {
            url: '/departments',
            templateUrl: 'app/pages/station/departments/template.html',
            controller: "stationDepartmentsCtrl",
            //controllerAs: "",
            title: 'Departments',
            sidebarMeta: {
                order: 70,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.sales.total', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('sales.total', {
            url: '/total',
            templateUrl: 'app/pages/sales/total/template.html',
            controller: "salesTotalCtrl",
            //controllerAs: "",
            title: 'Total Sales',
            sidebarMeta: {
                order: 10,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.departmentcreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.departmentCreate', {
            url: '/department/create',
            templateUrl: 'app/pages/station/departments-create/template.html',
            controller: "stationDepartmentCreateCtrl",
            //controllerAs: "",
            title: 'New Department',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.departmentdetails', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.departmentDetails', {
            url: '/department/:departmentId/details',
            templateUrl: 'app/pages/station/departments-details/template.html',
            controller: "stationDepartmentDetailsCtrl",
            //controllerAs: "",
            title: 'Department Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.fuelpurchases', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.fuelpurchases', {
            url: '/fuel-purchases',
            templateUrl: 'app/pages/station/fuel-purchases/template.html',
            controller: "stationFuelPurchasesCtrl",
            //controllerAs: "",
            title: 'Fuel Purchases',
            sidebarMeta: {
                order: 60,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.details', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.details', {
            url: '/details',
            templateUrl: 'app/pages/station/details/template.html',
            controller: "stationDetailsCtrl",
            //controllerAs: "",
            title: 'Station Details',
            sidebarMeta: {
                order: 10,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.fuelpurchaseCreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.fuelpurchaseCreate', {
            url: '/fuel-purchases/create',
            templateUrl: 'app/pages/station/fuel-purchases-create/template.html',
            controller: "stationFuelPurchaseCreateCtrl",
            //controllerAs: "",
            title: 'New Fuel Purchase',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.pumpscalibrate', ['angular.filter'])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.pumpsCalibrate', {
            url: '/pumps/calibrate',
            templateUrl: 'app/pages/station/pumps-calibrate/template.html',
            controller: "stationPumpsCalibrateCtrl",
            //controllerAs: "",
            title: 'Calibrate Nozzle Readings',
            // sidebarMeta: {
            //     order: 40,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.receiptsfooters', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.footers', {
            url: '/footers',
            templateUrl: 'app/pages/station/receipts-footers/template.html',
            controller: "receiptFootersCtrl",
            //controllerAs: "",
            title: 'Receipts Footers',
            sidebarMeta: {
                order: 20,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.pumps', ['angular.filter'])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.pumps', {
            url: '/pumps',
            templateUrl: 'app/pages/station/pumps/template.html',
            controller: "stationPumpsCtrl",
            //controllerAs: "",
            title: 'Pumps',
            sidebarMeta: {
                order: 40,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.fuelrates', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.fuelrates', {
            url: '/fuel-rates',
            templateUrl: 'app/pages/station/fuel-rates/template.html',
            controller: "stationFuelRatesCtrl",
            //controllerAs: "",
            title: 'Fuel Rates',
            sidebarMeta: {
                order: 50,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.receiptsfooterscreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.receiptsFootersCreate', {
            url: '/footer/create',
            templateUrl: 'app/pages/station/receipts-footers-create/template.html',
            controller: "stationReceiptsFootersCreateCtrl",
            //controllerAs: "",
            title: 'New Receipts Footers',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.receiptsfootersdetails', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.receiptsFootersDetail', {
            url: '/footer/:footerId/details',
            templateUrl: 'app/pages/station/receipts-footers-details/template.html',
            controller: "stationReceiptsFootersDetailsCtrl",
            //controllerAs: "",
            title: 'Receipts Footers Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.suppliers', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.suppliers', {
            url: '/suppliers',
            templateUrl: 'app/pages/station/suppliers/template.html',
            controller: "stationSuppliersCtrl",
            //controllerAs: "",
            title: 'Suppliers',
            sidebarMeta: {
                order: 80,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.suppliercreate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.supplierCreate', {
            url: '/supplier/create',
            templateUrl: 'app/pages/station/suppliers-create/template.html',
            controller: "stationSupplierCreateCtrl",
            //controllerAs: "",
            title: 'New Supplier',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.supplierdetails', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.supplierDetails', {
            url: '/supplier/:supplierId/details',
            templateUrl: 'app/pages/station/suppliers-details/template.html',
            controller: "stationSupplierDetailsCtrl",
            //controllerAs: "",
            title: 'Supplier Details',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.tanks', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.tanks', {
            url: '/tanks',
            templateUrl: 'app/pages/station/tanks/template.html',
            controller: "stationTanksCtrl",
            //controllerAs: "",
            title: 'Tanks',
            sidebarMeta: {
                order: 30,
            }
        });
    }

})();

(function () {
  'use strict';

  angular.module('xoil.pages.station.tankscalibrate', [])
    .config(routeConfig);

  /** @ngInject */
    function routeConfig($stateProvider,$urlRouterProvider) {
        $stateProvider
        .state('station.tankscalibrate', {
            url: '/tanks/calibrate',
            templateUrl: 'app/pages/station/tanks-calibrate/template.html',
            controller: "stationTanksCalibrateCtrl",
            //controllerAs: "",
            title: 'Tanks Readings',
            // sidebarMeta: {
            //     order: 10,
            // }
        });
    }

})();

'use strict';

angular.module('BlurAdmin', [
  'ngSanitize',
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'AngularPrint',
  'xoil.services',

  'BlurAdmin.theme',
  'xoil.services',
  'xoil.pages',
  'xoil.components',

]).run( function( authService, authServiceApi ){ // authService
  
  authServiceApi.verify();
  
});

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 0); // 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author Patrick Agius
 * created on 2018-09-03
 */
(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('authService', [
    '$rootScope', 
    function ( $rootScope ) {

        var _store = {
            authenticated: false,
            user: undefined,
        };
        
        $rootScope.userAuthenticated = false;

        var _fnLoggedIn = function( userData ){
            _store.authenticated = true;
            $rootScope.userAuthenticated = true;
            _store.user = userData;
        }

        var _fnLoggedOut = function(){
            _store.authenticated = false;
            $rootScope.userAuthenticated = false;
            _store.user = undefined;
        }        

        return {
            loggedIn: _fnLoggedIn,
            loggedOut: _fnLoggedOut,
        };

    }]);

})();

/**
 * @author Patrick Agius
 * created on 2018-09-03
 */
(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('authServiceApi', [
    '$q', '$rootScope', 'httpService', 'authService', 
    function ( $q, $rootScope, httpService, authService ) {

        var _fnVerify = function(){
            var deferred = $q.defer();

            httpService.request.json( 'GET', '/api/auth/' ).then( function( response ) {
                authService.loggedIn( response.data.data.user );
                deferred.resolve();
            }, function( error ) { 
                deferred.resolve();
            }, function( notification ) { 

            });

            return deferred.promise;
        }

        var _fnLogout = function(){
            var deferred = $q.defer();

            httpService.request.json( 'GET', '/api/auth/logout' ).then( function( response ) {
                authService.loggedOut();
                deferred.resolve();
            }, function( error ) { 
                deferred.resolve();
            }, function( notification ) { 

            });            

            return deferred.promise;
        }

        var _fnLogin = function( username, password ){
            var deferred = $q.defer();

            httpService.request.json( 'POST', '/api/auth', {}, {
                'username': username,
                'password': password,
            } ).then( function( response ) {
                if( response.data.success ){
                    authService.loggedIn( response.data.data.user );
                }
                deferred.resolve();
            }, function( error ) { 
                deferred.resolve();
            }, function( notification ) { 

            });             

            return deferred.promise;
        }

        return {
            login: _fnLogin,
            logout: _fnLogout,
            verify: _fnVerify, 
        };
    }]);

})();

(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('companyLoaderService', [
        function ( ) {

            var selectedCompany = {
                data: {
                    "id": 0,
                    "name": "All Companies"
                },
                lastSref: '',
            }

            // var _fnSelect = function( id, name ){
            //     selectedCompany.id = id;
            //     selectedCompany.name = name;
            // }
            var _fnIfDefaultSetId = function( id ){
                if( selectedCompany.data.id == 0 ){
                    selectedCompany.data.id = id;
                }
            }

            return {
                //select: _fnSelect,
                getSelection: selectedCompany,
                ifDefaultSetId: _fnIfDefaultSetId
            }
        }
    ]);
    
})();

(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('companyReportsService', [
        function ( ) {

            var data = {
                newPostPayPosting: {
                    "PostingDate": new Date(),
                },
            }

            return {
                data: data,
            }
        }
    ]);
    
})();

(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('dateTimeFromToService', [
        function ( ) {

            var dates = {
                from: null,
                to: null,
            }

            var _fnDefault = function(){
                var today = new Date();
                //var today = new Date(2018, 3, 15, 0, 0, 0, 0);
                dates.from = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                dates.to = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
            }

            _fnDefault();

            return {
                dates: dates,
                default: _fnDefault,
            };
        }
    ]);
    
})();

/**
 * @author Patrick Agius
 * created on 2018-09-03
 */
(function () {
    'use strict';

    angular.module('xoil.services')
    .factory('httpService', [
    '$http', '$q', '$rootScope', 'authService',
    function ( $http, $q, $rootScope, authService ) {

        var _fnHttpJson = function( method, url, params, data ){
            var deferred = $q.defer();
            $http({
                method:  method,
                url:     url,
                headers: { 
                    'Content-Type': 'application/json', 
                    'cache-control': 'no-cache', 
                }, 
                params: params,
                data: data,
                cache: false
            }).success( function( data, status, headers, config ) {

                deferred.resolve({
                    data: data, 
                    status: status, 
                    //headers: headers, 
                    //config: config,
                });

            }).error( function( data, status, headers, config ) {

                switch( status ){
                    case 401: 
                        authService.loggedOut();
                        break;
                    default:

                        break;
                }

                deferred.reject({
                    data: data, 
                    status: status, 
                    //headers: headers, 
                    //config: config,
                });

            });

            return deferred.promise;
        }

        return {
            request: {
                json: _fnHttpJson,
            }
        };

    }]);

})();

/**
* @author Patrick Agius
* created on 2018-12-30
*/
(function () {
    'use strict';

    angular.module('xoil.pages')
    .controller('loginCtrl', loginCtrl);

    /** @ngInject */
    function loginCtrl( $scope, authServiceApi ) {

        var _reset = function(){
            $scope.username = '';
            $scope.password = '';
        }

        _reset();

        $scope.signin = function(){
            authServiceApi.login( $scope.username, $scope.password ).then( function(){
                _reset();
            });
        }

    }

})();

/**
* @author Patrick Agius
* created on 2018-12-30
*/
(function () {
    'use strict';

    angular.module('xoil.pages')
    .controller('logoutCtrl', logoutCtrl);

    /** @ngInject */
    function logoutCtrl( $scope, authServiceApi ) {

        $scope.signOut = function(){
            authServiceApi.logout().then( function(){

            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('xoil.components').controller('adminOptionsCtrl', adminOptionsCtrl);

    /** @ngInject */
    function adminOptionsCtrl( $scope, $timeout, $http, authService, $uibModal, toastr ) {

        $scope.fnShutdownRestart = function(){
            var modalInstance = _fnOpenModal('app/components/admin-options/shutdown-restart.html', 'sm');
            modalInstance.result.then( function( selectedItem ) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    _fnShutdown('restart');
                }
            });
        }

        $scope.fnShutdownHalt = function(){
            var modalInstance = _fnOpenModal('app/components/admin-options/shutdown-halt.html', 'sm');
            modalInstance.result.then( function( selectedItem ) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    _fnShutdown('halt');
                }
            });
        }

        $scope.fnResetSystem = function(){
            var modalInstance = _fnOpenModal('app/components/admin-options/reset-system.html', 'sm');
            modalInstance.result.then( function( selectedItem ) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    _fnReset('all');
                }
            });
        }

        $scope.fnResetPumps = function(){
            var modalInstance = _fnOpenModal('app/components/admin-options/reset-pumps.html', 'sm');
            modalInstance.result.then( function( selectedItem ) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    _fnReset('pumps');
                }
            });
        }

        $scope.fnResetAccountsInUse = function(){
            var modalInstance = _fnOpenModal('app/components/admin-options/reset-accounts-in-use.html', 'sm');
            modalInstance.result.then( function( selectedItem ) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    _fnReset('accounts-in-use');
                }
            });
        }

        var _fnOpenModal = function (page, size) {
            return $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                // resolve: {
                //     items: function () {
                //         return $scope.items;
                //     }
                // }
            });
        };

        var _fnShutdown = function( option ){
            $http({
                method: 'post', 
                url: '/api/admin/shutdown/' + option,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    toastr.success('Command submitted!');
                }else{
                    toastr.error('Something went wrong!');
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });            
        }

        var _fnReset = function( option ){
            $http({
                method: 'post', 
                url: '/api/admin/reset/' + option,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    toastr.success('Reset command submitted!');
                }else{
                    toastr.error('Something went wrong!');
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });            
        }

    }
    
})();
(function () {
  'use strict';

  angular.module('xoil.components')
      .directive('adminOptions', adminOptions);

  /** @ngInject */
  function adminOptions() {
    return {
      restrict: 'E',
      controller: 'adminOptionsCtrl',
      templateUrl: 'app/components/admin-options/template.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('autoDataTableComponent', autoDataTableComponent);

    /** @ngInject */
    function autoDataTableComponent() {
        return {
            restrict: 'E',
            controller: 'autoDataTableCtrl',
            templateUrl: 'app/components/auto-data-table/auto-data-table.html',
            transclude: true,
            scope: {
                heading: '=',
                server: '=',
                data: '=',
                headersBreakLine: '=',
                totals: '=',
                currencies: '=',
                decimals: '=',
                functions: '=',
                pagingEnabled: '=',
                pageSize: '=',
                styles: '=',
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .controller('autoDataTableCtrl', autoDataTableCtrl);

    /** @ngInject */
    function autoDataTableCtrl( $scope ) {

        $scope.pagingColSpan = 1;
        $scope.pagingShow = false;

        $scope.colTotals = {};

        $scope.pageSize1 = 10;

        // if( $scope.pageSize == undefined ){
        //     $scope.pageSize = 20;
        // }
        //console.log(  $scope.pageSize1 );
        $scope.fnTest = function(){
            console.log(  $scope.pageSize1 );
        }

        $scope.getStyle = function( k, v ){
            if( $scope.styles != undefined ){
                if( $scope.styles[k] != undefined ){
                    return {'text-align':$scope.styles[k]};
                }
            }
            if( isNaN( v ) ){
                return {'text-align':'left'};
            }else{
                return {'text-align':'right'};
            }
        }

        $scope.getFormat = function( key, value ){
            var n = value;
            var negative = false;
            if( $scope.currencies != undefined ){
                if( $scope.currencies.indexOf( key ) > -1 ){
                    negative = ( value < 0 );
                    n = parseFloat( value ) + '';
                    if( n.indexOf('.') > -1 ){
                        n += '00001';
                    }else{
                        n += '.00001';
                    }
                    var parts = n.split(".");
                    var i = Number( parts[0] ).toLocaleString( 'en' );
                    var d = parts[1].substring( 0, 2 );
                    if( negative ){
                        return '€-' + i + '.' + d;
                    }
                    return '€' + i + '.' + d;
                }
            }
            if( $scope.decimals != undefined ){
                if( $scope.decimals[ key ] != undefined ){
                    negative = ( value < 0 );
                    n = parseFloat( value ) + '';
                    if( n.indexOf('.') > -1 ){
                        n += '00001';
                    }else{
                        n += '.00001';
                    }
                    var parts = n.split(".");
                    var i = Number( parts[0] ).toLocaleString( 'en' );
                    var d = parts[1].substring( 0, $scope.decimals[ key ] );
                    if( negative ){
                        if( $scope.decimals[ key ] > 0 ){
                            return '-' + i + '.' + d;
                        }
                        return '-' + i;
                    }
                    if( $scope.decimals[ key ] > 0 ){
                        return i + '.' + d;
                    }
                    return i;

                    // n = parseFloat( value );
                    // n += 0.000001;
                    // n += '';
                    // var parts = n.split(".");
                    // var i = Number( parts[0] ).toLocaleString( 'en' );
                    // if( parts.length > 1 ){
                    //     var d = parts[1].substring( 0, $scope.decimals[ key ] );
                    //     return i + '.' + d;
                    // } else {
                    //     return i;
                    // }
                }
            }            
            return n;
        }

        $scope.processValue = function( row, key, value ){
            //console.log( $scope.data, row, key, value );
            var v = $scope.getFormat( key, value );
            if( $scope.functions != undefined ){
                if( $scope.functions[key] != undefined ){
                    v = $scope.functions[key]( row, key, v, $scope );
                }
            }
            return v;
        }

        $scope.getTotal = function( key ){
            if( $scope.colTotals[key] != undefined ){
                return $scope.getFormat( key, $scope.colTotals[key] );
            }
            return '';
        }

        $scope.$watch('data', function (newValue, oldValue, scope) {
//console.log( newValue, oldValue );
            if( $scope.data[0] != undefined ){
                $scope.pagingColSpan = Object.keys($scope.data[0]).length;
            }

            $scope.pagingShow = ( $scope.data.length >= $scope.pageSize );

            if( $scope.totals != undefined ){

                $scope.colTotals = {};

                for( var c1=0; c1<$scope.totals.length; c1++ ){
                    $scope.colTotals[ $scope.totals[c1] ] = 0;
                    for( var c2=0; c2<$scope.data.length; c2++ ){
                        if( $scope.data[c2][ $scope.totals[c1] ] != undefined ){
                            $scope.colTotals[ $scope.totals[c1] ] += $scope.data[c2][ $scope.totals[c1] ];
                        }
                    }
                    $scope.colTotals[ $scope.totals[c1] ] = Math.round( $scope.colTotals[ $scope.totals[c1] ] * 100 ) / 100;
                }
            }
        }, true);

    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('bindHtmlCompile', bindHtmlCompile);

    /** @ngInject */
    function bindHtmlCompile( $compile ) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
//console.log( scope, element, attrs );
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('dateComponent', dateComponent);

    /** @ngInject */
    function dateComponent() {
        //console.log(1);
        return {
            restrict: 'E',
            controller: 'dateCtrl',
            templateUrl: 'app/components/date/date.html',
            transclude: true,
            scope: {
                value: '=',
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .controller('dateCtrl', dateCtrl);

    /** @ngInject */
    function dateCtrl( $scope ) {

        $scope.opened = false;
        $scope.format = 'dd MMM yy';
        $scope.options = {
            showWeeks: false
        }

        $scope.open = function() {
            $scope.opened = true;
        };

    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
    .controller('companyLoaderCtrl', companyLoaderCtrl);

    /** @ngInject */
    function companyLoaderCtrl( $scope, $http, $state, authService, companyLoaderService ) {
        $scope.companies = {
            records: [],
        };

        $scope.selectedCompany = companyLoaderService.getSelection;

        $scope.fnOnSelect = function( item ){
            // console.log( item );
            // companyLoaderService.getSelection.lastSref
            // {id: 254, name: "AG - AG Installations", $$hashKey: "object:301"}

            $state.go( companyLoaderService.getSelection.lastSref, { companyId: item.id } );
        }

        var fnLoadCompanies = function(){
            $http({
                method: 'get', 
                url: '/api/companies-short',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.companies.records = [];
                    response.data.records.forEach(function( company ) {

                        if( company.id == $scope.selectedCompany.data.id ){
                            $scope.selectedCompany.data.name = company.code + ' - ' + company.name;
                        }

                        $scope.companies.records.push({
                            id: company.id,
                            name: company.code + ' - ' + company.name,
                        })

                        //console.log( $state );
                    });
                    //console.log( $scope.selectedCompany );
                }else{
                    console.log( 'issue' );
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }  

        fnLoadCompanies();      
    }

})();
(function () {
  'use strict';

  angular.module('xoil.components')
      .directive('companyLoaderComponent', companyLoaderComponent);

  /** @ngInject */
  function companyLoaderComponent() {
    //console.log(1);
    return {
      restrict: 'E',
      controller: 'companyLoaderCtrl',
      templateUrl: 'app/components/company-loader/template.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('dateTimeFromToComponent', dateTimeFromToComponent);

    /** @ngInject */
    function dateTimeFromToComponent() {
        return {
            restrict: 'E',
            controller: 'dateTimeFromToCtrl',
            templateUrl: 'app/components/date-time-from-to/date-time-from-to.html',
            transclude: true,
            scope: {
                fromDateTime: '=',
                toDateTime: '=',
                submit: '=',
                default: '=',
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .controller('dateTimeFromToCtrl', dateTimeFromToCtrl);

    /** @ngInject */
    function dateTimeFromToCtrl( $scope ) {

    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('xoil.components')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      // scope: {
      //   ngModel: '=',
      // },
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
(function () {
    'use strict';

    angular.module('xoil.components').controller('operationModeCtrl', operationModeCtrl);

    /** @ngInject */
    function operationModeCtrl( $scope, $timeout, $http, authService ) {
        $scope.om = {
            loaded: true,
            mode: 'scheduler',
            modeSelected: '',
            modePassword: '',
            screen: 0,
            needPassword: false,
            updating: false
        }

        $scope.changeMode = function( mode ){
            $scope.om.modeSelected = mode;
            $scope.changeScreen(2);
        }

        $scope.changeScreen = function( screen ){
            $scope.om.screen = screen;
        }

        $scope.confirmMode = function(){
            // $scope.om.modeSelected
            $http({
                method: 'post', url: '/api/admin/set/operation-mode', data: { 
                    mode: $scope.om.modeSelected, 
                    password: $scope.om.modePassword 
                }
            }).then(function success(response) {
                //console.log( response );
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
            $scope.om.modePassword = '';
            $scope.om.modeSelected = '';
            $scope.changeScreen(3);
        }

        var update = function(){
          //console.log( 'mtx update' );
          $http({
            method: 'get', url: '/api/system-info/operation-mode', params: {}
          }).then(function success(response) {
            //$scope.mtx.data = response.data;
            //console.log( response.data );
            if( response.data.success ) {
                if( response.data.records.length == 1 ) {
                    $scope.om.updating = false;
                    $scope.om.needPassword = response.data.records[0].needPassword == "1";
                    $scope.om.mode = response.data.records[0].currentMode;
                    if( response.data.records[0].updatePending == 0 && $scope.om.screen == 3 ){
                        $scope.changeScreen(0);
                    }
                }
            }
          }, function error( error ) {
              if( error.status == 401 ){
                  authService.loggedOut();
              }else{
                  console.log("error", error);
                  toastr.error('An Error Occured!');
              }
          });

          var pull = $timeout( function(){
            update();
          },2000);

          $scope.$on('$destroy', function(){
            $timeout.cancel(pull);
          });
        }

        update();

    }
    
})();
(function () {
  'use strict';

  angular.module('xoil.pages.dashboard')
      .directive('operationMode', operationMode);

  /** @ngInject */
  function operationMode() {
    //console.log(1);
    return {
      restrict: 'E',
      controller: 'operationModeCtrl',
      templateUrl: 'app/components/operation-mode/template.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('xoil.components')
    .controller('listTransactionCtrl', listTransactionCtrl);

    /** @ngInject */
    function listTransactionCtrl( $scope, $timeout, $http, authService, $uibModal, toastr ) {
        $scope.mtx = {};
        $scope.mtx.data = {};
        $scope.mtx.lastSuccess = 0;

        var update = function(){
            $http({
                method: 'get', 
                url: '/api/sales/latest', 
                params: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.mtx.data = response.data.records;
                    $scope.mtx.lastSuccess = Date();
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

            var pull = $timeout( function(){
                update();
            },2000);

            $scope.$on('$destroy', function(){
                $timeout.cancel(pull);
            });

        }

        update();

        $scope.fnNewKioskSale = function( pumpId ){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/last-transaction/new-kiosk-sale.html',
                size: 'sm',
                controller: 'ModalNewKioskSaleCtrl',
            });
            modalInstance.result.then( function (selectedItem) {
                
            }, function ( amount ) {
                if( amount != undefined ) {
                    if( amount > 0 ){
                        $http({
                            method: 'post', 
                            url: '/api/admin/new-kiosk-sale/' + pumpId + '/' + amount,
                            params: {},
                            headers: {},
                            data: {}
                        }).then(function success(response) {
                            if( response.data.success ){
                                toastr.success('Kiosk Sale command submitted!');
                            }else{
                                toastr.error('Something whent wrong!');
                            }
                        }, function error( error ) {
                            if( error.status == 401 ){
                                authService.loggedOut();
                            }else{
                                console.log("error", error);
                                toastr.error('An Error Occured!');
                            }
                        });
                    } else {
                        toastr.error('Invalid amount entered!');
                    }
                }
            });

        }

        $scope.fnPumpTurnOn = function( pumpId ){
            var modalInstance = _fnOpenModal('app/components/last-transaction/turn-on-modal.html', 'sm');
            modalInstance.result.then( function (selectedItem) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    $http({
                        method: 'post', 
                        url: '/api/admin/pump-on/' + pumpId,
                        params: {},
                        headers: {},
                        data: {}
                    }).then(function success(response) {
                        if( response.data.success ){
                            toastr.success('Turn On command submitted!');
                        }else{
                            toastr.error('Something whent wrong!');
                        }
                    }, function error( error ) {
                        if( error.status == 401 ){
                            authService.loggedOut();
                        }else{
                            console.log("error", error);
                            toastr.error('An Error Occured!');
                        }
                    });
                }
            });
        }

        $scope.fnPumpTurnOff = function( pumpId ){
            var modalInstance = _fnOpenModal('app/components/last-transaction/turn-off-modal.html', 'sm');
            modalInstance.result.then( function (selectedItem) {
                //console.log( selectedItem );
            }, function ( command ) {
                if( command == 'confirm' ){
                    $http({
                        method: 'post', 
                        url: '/api/admin/pump-off/' + pumpId,
                        params: {},
                        headers: {},
                        data: {}
                    }).then(function success(response) {
                        if( response.data.success ){
                            toastr.success('Turn Off command submitted!');
                        }else{
                            toastr.error('Something whent wrong!');
                        }
                    }, function error( error ) {
                        if( error.status == 401 ){
                            authService.loggedOut();
                        }else{
                            console.log("error", error);
                            toastr.error('An Error Occured!');
                        }
                    });
                }
            });            
        }

        var _fnOpenModal = function (page, size) {
            return $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                // resolve: {
                //     items: function () {
                //         return $scope.items;
                //     }
                // }
            });
        };

    }

    angular.module('xoil.components')
    .controller('ModalNewKioskSaleCtrl', ModalNewKioskSaleCtrl);

    /** @ngInject */
    function ModalNewKioskSaleCtrl( $scope ) {
        $scope.amount = 0.00;
    }

})();
(function () {
  'use strict';

  angular.module('xoil.components')
      .directive('lastTransaction', monTransaction);

  /** @ngInject */
  function monTransaction() {
    //console.log(1);
    return {
      restrict: 'E',
      controller: 'listTransactionCtrl',
      templateUrl: 'app/components/last-transaction/template.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('xoil.components').controller('slaveStatusCtrl', slaveStatusCtrl);

    /** @ngInject */
    function slaveStatusCtrl( $scope, $timeout, $http, authService ) {
        $scope.ss = {
            loaded: false,
            configured: false,
            connected: false,
            running: false
        }

        var update = function(){
          $http({
            method: 'get', url: '/api/system-info/show-other-slave-status', params: {}
          }).then(function success(response) {
            $scope.ss.loaded = true;
            // console.log(response.data);
            if( response.data.success ) {
                $scope.ss.configured = response.data.Master_Host == '' ? false : true;
                $scope.ss.connected = response.data.Slave_IO_Running == 'Yes' ? true : false;
                $scope.ss.running = response.data.Slave_SQL_Running == 'Yes' ? true : false;
                // console.log($scope.ss);
            }
          }, function error( error ) {
              if( error.status == 401 ){
                  authService.loggedOut();
              }else{
                  console.log("error", error);
                  toastr.error('An Error Occured!');
              }
          });

          var pull = $timeout( function(){
            update();
          },4000);

          $scope.$on('$destroy', function(){
            $timeout.cancel(pull);
          });
        }

        update();

    }
    
})();
(function () {
  'use strict';

  angular.module('xoil.pages.dashboard')
      .directive('slaveStatus', slaveStatus);

  /** @ngInject */
  function slaveStatus() {
    //console.log(1);
    return {
      restrict: 'E',
      controller: 'slaveStatusCtrl',
      templateUrl: 'app/components/slave-status/template.html'
    };
  }
})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('timeComponent', timeComponent);

    /** @ngInject */
    function timeComponent() {
        //console.log(1);
        return {
            restrict: 'E',
            controller: 'timeCtrl',
            templateUrl: 'app/components/time/time.html',
            transclude: true,
            scope: {
                value: '=',
            }
        };
    }

})();
(function () {
    'use strict';

    angular.module('xoil.components')
        .controller('timeCtrl', timeCtrl);

    /** @ngInject */
    function timeCtrl( $scope ) {

        //$scope.mytime = new Date();
        $scope.hstep = 1;
        $scope.mstep = 1;
        $scope.ismeridian = false;

    }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author Patrick Agius
 * created on 2018-09-03
 */
// (function () {
//   'use strict';

//   angular.module('xoil.services')
//   .factory('authService', [
//     '$http', 
//     function ($http) {
//       console.log( 'authService2' );
//       return {};
//     }
//   ]);

  

// })();

(function(){
    'use strict';

    angular.module('xoil.pages.attendants.create')
        .controller('attendantsCreateCtrl', attendantsCreateCtrl);

    /** @ngInject */
    function attendantsCreateCtrl( $scope, $http, authService, $stateParams, $state, toastr ) {
        var today = new Date();
        $scope.data = {
            detailsRecords: [
                {  
                   "AttendantCode":"",
                   "Name":"",
                   "Surname":"",
                   "IdNumber":"",
                   "NiNumber":"",
                   "Address1":"",
                   "Address2":"",
                   "City":"",
                   "PostCode":"",
                   "FatherName":"",
                   "Tel":"",
                   "Fax":"",
                   "Mob":"",
                   "Email":"",
                   "Other":"",
                   "EmploymentDate": new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                   "TerminationDate": new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                   "Terminated":false
                }
             ],
        }

        $scope.forms = { };

        $scope.createAttendant = function(){
            if ( $scope.forms.details.$valid ) {
                //console.log( $stateParams.attendantId, $scope.data.detailsRecords[0] );
                $http({
                    method: 'put', 
                    url: '/api/attendant/details',
                    params: {},
                    headers: {},
                    data: $scope.data.detailsRecords[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        var params = {
                            attendantId: response.data.insertId, 
                        };
                        $state.go( 'attendants.details', params );
                        toastr.success('Created successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }        

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.attendants.list')
        .controller('attendantsListCtrl', attendantsListCtrl);

    /** @ngInject */
    function attendantsListCtrl( $scope, $http ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.fnLoad = function(){
            $scope.title = '';
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/attendants/',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                console.log( 'error', error );
            });
        }

        $scope.fnDetailsLink = function( row, key, value ){
            return "<a ui-sref=\"attendants.details({attendantId:" + value + "})\">View</a>";
        }  

        $scope.fnLoad();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.accountdetails')
        .controller('companiesAccountDetailsCtrl', companiesAccountDetailsCtrl);

    /** @ngInject */
    function companiesAccountDetailsCtrl( $scope, $http, authService, $stateParams, $uibModal, toastr, companyLoaderService ) {

        companyLoaderService.ifDefaultSetId( $stateParams.companyId );

        $scope.data = {
            details: [],
            fuels: [],
            periods: [],
            types: [],
        };

        $scope.forms = { };

        var _fnConvertToBoolean = function( field ){
            $scope.data.details[0][field] = ($scope.data.details[0][field] != 0);
        }

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"] + '/account/' + $stateParams["accountId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                    $scope.data.types = response.data.accountTypes;
                    $scope.data.periods = response.data.limitsPeriod;
                    $scope.data.fuels = response.data.fuelTypes;

                    $scope.data.fuels.push({
                        id:0,
                        name:'All',
                    });
                    
                    _fnConvertToBoolean( 'PublicHolidays' );
                    _fnConvertToBoolean( 'Monday' );
                    _fnConvertToBoolean( 'Tuesday' );
                    _fnConvertToBoolean( 'Wednesday' );
                    _fnConvertToBoolean( 'Thursday' );
                    _fnConvertToBoolean( 'Friday' );
                    _fnConvertToBoolean( 'Saturday' );
                    _fnConvertToBoolean( 'Sunday' );
                    _fnConvertToBoolean( 'MileageRequired' );

                    var t1 = $scope.data.details[0].Issued + '';
                    $scope.data.details[0].Issued = new Date(
                        t1.substring(0, 4), 
                        t1.substring(4, 6) - 1, 
                        t1.substring(6, 8), 
                        0, 0, 0
                    );

                    var today = new Date();

                    if( $scope.data.details[0].Expired == 0 || $scope.data.details[0].Expired == '' ){
                        $scope.data.details[0].hasExpired = false;
                        $scope.data.details[0].Expired = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                    } else {
                        t1 = $scope.data.details[0].Expired + '';
                        $scope.data.details[0].Expired = new Date(
                            t1.substring(0, 4), 
                            t1.substring(4, 6) - 1, 
                            t1.substring(6, 8), 
                            0, 0, 0
                        );
                        $scope.data.details[0].hasExpired = true;
                    }

                    t1 = $scope.data.details[0].FromTime + 1000000;
                    t1 = t1 + '';
                    $scope.data.details[0].FromTime = new Date(
                        today.getFullYear(), 
                        today.getMonth(), 
                        today.getDate(), 
                        t1.substring(1, 3), 
                        t1.substring(3, 5), 
                        0
                    );

                    t1 = $scope.data.details[0].ToTime + 1000000;
                    t1 = t1 + '';
                    $scope.data.details[0].ToTime = new Date(
                        today.getFullYear(), 
                        today.getMonth(), 
                        today.getDate(), 
                        t1.substring(1, 3), 
                        t1.substring(3, 5), 
                        0
                    );

                    for( var c1=0; c1<$scope.data.types.length; c1++ ){
                        if( $scope.data.types[c1].id == $scope.data.details[0].AccountTypeID ){
                            $scope.data.details[0].AccountTypeID = $scope.data.types[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].AccountTypeID );

                    for( var c1=0; c1<$scope.data.periods.length; c1++ ){
                        if( $scope.data.periods[c1].id == $scope.data.details[0].LimitPeriodID ){
                            $scope.data.details[0].LimitPeriodID = $scope.data.periods[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].LimitPeriodID );

                    for( var c1=0; c1<$scope.data.fuels.length; c1++ ){
                        if( $scope.data.fuels[c1].id == $scope.data.details[0].FuelId ){
                            $scope.data.details[0].FuelId = $scope.data.fuels[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].FuelId );


                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.updateRecord = function(){
            if ( $scope.forms.details.$valid ) {
                $http({
                    method: 'post', 
                    url: '/api/company/' + $stateParams["companyId"] + '/account/' + $stateParams["accountId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        if (response.data.message !== undefined) {
                            toastr.error(response.data.message);
                        } else {
                            toastr.error('Something whent wrong!');
                        }
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

        $scope.fnResetAmountTaken = function(){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/companies/account-details/reset-amount-taken.html',
                size: 'sm',
            });
            modalInstance.result.then( function (selectedItem) {
                
            }, function ( command ) {
                if( command == 'confirm' ){
                    $http({
                        method: 'post', 
                        url: '/api/company/' + $stateParams["companyId"] + '/account/' + $stateParams["accountId"] + '/reset-balance',
                        params: {},
                        headers: {},
                        data: {}
                    }).then(function success(response) {
                        if( response.data.success ){
                            $scope.data.details[0].AmountTaken = 0;
                            toastr.success('Amount Taken Reset Successful!');
                        }else{
                            toastr.error('Something whent wrong!');
                        }
                    }, function error( error ) {
                        if( error.status == 401 ){
                            authService.loggedOut();
                        }else{
                            console.log("error", error);
                            toastr.error('An Error Occured!');
                        }
                    });
                }
            });
        }
           
        $scope.getRecords();
        
    }

})();

/*

{  
   "success":true,
   "records":[  
      {  
         "AccountId":1035,
         "CompanyId":240,
         "iButtonID":"0F0000596E10F101",
         "AccountCode":"AAA111",
         "ClientName":"Patrick Test",
         "Issued":20190330,
         "Expired":0,
         "LimitAmount":80,
         "AmountTaken":0,
         "LimitPeriodID":3,
         "LimitTypeID":1,
         "FuelId":0,
         "FromTime":0,
         "ToTime":0,
         "BlackListed":0,
         "PublicHolidays":1,
         "AccountTypeID":1,
         "PrePaidInAc":50,
         "Monday":1,
         "Tuesday":1,
         "Wednesday":1,
         "Thursday":1,
         "Friday":1,
         "Saturday":1,
         "Sunday":1,
         "Pin":"3083",
         "MileageRequired":0
      }
   ]
}

*/
(function(){
    'use strict';

    angular.module('xoil.pages.companies.accountcreate')
        .controller('companiesAccountCreateCtrl', companiesAccountCreateCtrl);

    /** @ngInject */
    function companiesAccountCreateCtrl( $scope, $http, authService, $state, $stateParams, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [
                {
                    "iButtonID":"",
                    "AccountCode":"",
                    "ClientName":"",
                    "hasExpired": false,
                    "Issued": new Date(),
                    "Expired": new Date(),
                    "LimitAmount":0,
                    "AmountTaken":0,
                    "LimitPeriodID":3,
                    "LimitTypeID":1,
                    "FuelId":0,
                    "FromTime": new Date(2000, 0, 1, 0, 0, 0),
                    "ToTime": new Date(2000, 0, 1, 0, 0, 0),
                    "BlackListed":0,
                    "PublicHolidays":true,
                    "AccountTypeID":2,
                    "PrePaidInAc":0,
                    "Monday":true,
                    "Tuesday":true,
                    "Wednesday":true,
                    "Thursday":true,
                    "Friday":true,
                    "Saturday":true,
                    "Sunday":true,
                    "Pin":"" + (Math.floor(Math.random() * Math.floor(10))) + "" + (Math.floor(Math.random() * Math.floor(10))) + "" + (Math.floor(Math.random() * Math.floor(10))) + "" + (Math.floor(Math.random() * Math.floor(10))),
                    "MileageRequired":false 
                }
            ],
            fuels: [],
            periods: [],
            types: [],
        }

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"] + '/account',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.types = response.data.accountTypes;
                    $scope.data.periods = response.data.limitsPeriod;
                    $scope.data.fuels = response.data.fuelTypes;

                    $scope.data.fuels.push({
                        id:0,
                        name:'All',
                    });
                    
                    for( var c1=0; c1<$scope.data.types.length; c1++ ){
                        if( $scope.data.types[c1].id == $scope.data.details[0].AccountTypeID ){
                            $scope.data.details[0].AccountTypeID = $scope.data.types[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].AccountTypeID );

                    for( var c1=0; c1<$scope.data.periods.length; c1++ ){
                        if( $scope.data.periods[c1].id == $scope.data.details[0].LimitPeriodID ){
                            $scope.data.details[0].LimitPeriodID = $scope.data.periods[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].LimitPeriodID );

                    for( var c1=0; c1<$scope.data.fuels.length; c1++ ){
                        if( $scope.data.fuels[c1].id == $scope.data.details[0].FuelId ){
                            $scope.data.details[0].FuelId = $scope.data.fuels[c1];
                            break;
                        }
                    }
                    //console.log( $scope.data.details[0].FuelId );


                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            if ( $scope.forms.details.$valid ) {
                createRecordProcessing = true;
                $http({
                    method: 'put', 
                    url: '/api/company/' + $stateParams["companyId"] + '/account',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        var params = {
                            companyId: $stateParams["companyId"], 
                            accountId: response.data.insertId, 
                        };
                        $state.go( 'companyAccountDetails', params );                        
                        toastr.success('Account Created successfully!');
                    }else{
                        if (response.data.message !== undefined) {
                            toastr.error(response.data.message);
                        } else {
                            toastr.error('Something whent wrong!');
                        }
                    }
                    createRecordProcessing = false;
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                    createRecordProcessing = false;
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.attendants.details')
        .controller('attendantsDetailsCtrl', attendantsDetailsCtrl);

    /** @ngInject */
    function attendantsDetailsCtrl( $scope, $http, authService, $stateParams, $state, toastr ) {

        $scope.data = {
            detailsRecords: [],
            timetableRecords: [],
            ibuttonsRecords: [],
        }

        $scope.forms = { };

        $scope.iButton = {
            newIButton: '',
            newIButtonLimit: 0,
        }        

        $scope.title = '';

        $scope.fnLoadDetails = function(){
            $scope.title = '';
            $scope.data.detailsRecords = [];
            
            $http({
                method: 'get', 
                url: '/api/attendant/' + $stateParams.attendantId + '/details',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.detailsRecords = response.data.records;

                    var t1 = $scope.data.detailsRecords[0].EmploymentDate + '';
                    $scope.data.detailsRecords[0].EmploymentDate = new Date(
                        t1.substring(0, 4), 
                        t1.substring(4, 6) - 1, 
                        t1.substring(6, 8), 
                        0, 0, 0
                    );
                    
                    if( $scope.data.detailsRecords[0].TerminationDate == 0 || $scope.data.detailsRecords[0].TerminationDate == '' ){
                        $scope.data.detailsRecords[0].Terminated = false;
                        var today = new Date();
                        $scope.data.detailsRecords[0].TerminationDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
                    } else {
                        t1 = $scope.data.detailsRecords[0].TerminationDate + '';
                        $scope.data.detailsRecords[0].TerminationDate = new Date(
                            t1.substring(0, 4), 
                            t1.substring(4, 6) - 1, 
                            t1.substring(6, 8), 
                            0, 0, 0
                        );
                        $scope.data.detailsRecords[0].Terminated = true;
                    }

                    //$scope.title = $scope.data.detailsRecords.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.saveDetails = function(){
            if ( $scope.forms.details.$valid ) {
                //console.log( $stateParams.attendantId, $scope.data.detailsRecords[0] );
                $http({
                    method: 'post', 
                    url: '/api/attendant/' + $stateParams.attendantId + '/details',
                    params: {},
                    headers: {},
                    data: $scope.data.detailsRecords[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

        var _dayNo = [ '', 'Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thurs.', 'Fri.', 'Sat.' ];

        $scope.fnLoadTimeTables = function(){
            $scope.title = '';
            $scope.data.timetableRecords = [];
            
            $http({
                method: 'get', 
                url: '/api/attendant/' + $stateParams.attendantId + '/timetable',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.timetableRecords = response.data.records;

                    var today = new Date();
                    var c2 = 0;
                    for( var c1=0; c1<$scope.data.timetableRecords.length; c1++ ){

                        $scope.data.timetableRecords[ c1 ].dayno = _dayNo[ $scope.data.timetableRecords[ c1 ].dayno ];

                        if( $scope.data.timetableRecords[ c1 ].services == 1 ){
                            $scope.data.timetableRecords[ c1 ].services = true;
                        } else {
                            $scope.data.timetableRecords[ c1 ].services = false;
                        }

                        c2 = 1000000 + $scope.data.timetableRecords[ c1 ].starttime + '';
                        $scope.data.timetableRecords[ c1 ].starttime = new Date(
                            today.getFullYear(), 
                            today.getMonth(), 
                            today.getDate(), 
                            c2.substring(1,3), 
                            c2.substring(3,5), 
                            c2.substring(5,7)
                        );
                        
                        c2 = 1000000 + $scope.data.timetableRecords[ c1 ].endtime + '';
                        $scope.data.timetableRecords[ c1 ].endtime = new Date(
                            today.getFullYear(), 
                            today.getMonth(), 
                            today.getDate(), 
                            c2.substring(1,3), 
                            c2.substring(3,5), 
                            c2.substring(5,7)
                        );
                    }
                    //$scope.title = $scope.data.timetableRecords.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                console.log( 'error', error );
            });
        }

        $scope.saveTimeTable = function(){
            if ( $scope.forms.timeTable.$valid ) {
                //console.log( $stateParams.attendantId, $scope.data.timetableRecords );
                $http({
                    method: 'post', 
                    url: '/api/attendant/' + $stateParams.attendantId + '/timetable',
                    params: {},
                    headers: {},
                    data: $scope.data.timetableRecords
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

        $scope.fnLoadIButtons = function(){
            $scope.title = '';
            $scope.data.ibuttonsRecords = [];
            
            $http({
                method: 'get', 
                url: '/api/attendant/' + $stateParams.attendantId + '/ibuttons',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.ibuttonsRecords = response.data.records;
                    $scope.title = $scope.data.ibuttonsRecords.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.deleteIButton = function( iButton ){
            //console.log( $stateParams.attendantId, iButton );
            $http({
                method: 'delete', 
                url: '/api/attendant/' + $stateParams.attendantId + '/ibutton/' + iButton,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                        toastr.success('Deleted successfully!');
                        $scope.fnLoadIButtons();
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });

        }

        $scope.saveIButtons = function(){
            //console.log( $stateParams.attendantId, $scope.iButton );
            if ( $scope.forms.ibuttons.$valid ) {
                $http({
                    method: 'post', 
                    url: '/api/attendant/' + $stateParams.attendantId + '/ibutton/' + $scope.iButton.newIButton + '/' + $scope.iButton.newIButtonLimit,
                    params: {},
                    headers: {},
                    data: {}
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Created successfully!');
                        $scope.fnLoadIButtons();
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

        $scope.fnLoadDetails();
        $scope.fnLoadTimeTables();
        $scope.fnLoadIButtons();

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.accountslist')
        .controller('companiesAccountsListCtrl', companiesAccountsListCtrl);

    /** @ngInject */
    function companiesAccountsListCtrl( $scope, $http, authService, $state, $stateParams, companyLoaderService, toastr ) {

        companyLoaderService.ifDefaultSetId( $stateParams.companyId );

        companyLoaderService.getSelection.lastSref = 'companyAccounts';

        $scope.data = {
            postpay: [],
            // prepay: [],
            companyId: $stateParams.companyId,
        };

        $scope.getAccountsList = function( mode ){
            var url = '/api/company/' + $stateParams.companyId + '/' + mode + '-accounts';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data[mode] = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.getAccountsList( 'postpay' );
        // $scope.getAccountsList( 'prepay' );

        $scope.fnPostpayDetails = function( item ){
            $state.go( 'companyAccountDetails', { companyId: $stateParams.companyId, accountId: item.id } );
        }

        // $scope.fnPrepayDetails = function( item ){
        //     $state.go( 'companyAccountDetails', { companyId: $stateParams.companyId, accountId: item.id } );
        // }        

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.details')
        .controller('companiesDetailsCtrl', companiesDetailsCtrl);

    /** @ngInject */
    function companiesDetailsCtrl( $scope, $stateParams, $http, authService, toastr, companyLoaderService ) {

        companyLoaderService.ifDefaultSetId( $stateParams.companyId );

        companyLoaderService.getSelection.lastSref = 'companyDetails';

        $scope.data = {
            details: [],
        }

        $scope.forms = { };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;

                    if( $scope.data.details[0].Mileage != 0 ){
                        $scope.data.details[0].Mileage = true;
                    } else {
                        $scope.data.details[0].Mileage = false;
                    }
                    if( $scope.data.details[0].DocumentNr != 0 ){
                        $scope.data.details[0].DocumentNr = true;
                    } else {
                        $scope.data.details[0].DocumentNr = false;
                    }
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.updateRecord = function(){
            if ( $scope.forms.details.$valid ) {
                $http({
                    method: 'post', 
                    url: '/api/company/' + $stateParams["companyId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }
           
        $scope.getRecords();
    }

})();

/*
            "CompanyId": 240,
            "CompanyCode": "A.M.",
            "Name": "Waste Collection Service.",
            "Attention": "ADRIAN MUSCAT",
            "Address1": "131,MDINA ROAD ,",
            "Address2": "",
            "City": "ZEBBUG",
            "PostCode": "",
            "Country": "MALTA",
            "Tel": "27370000",
            "Fax": "",
            "Mob": "99341444 TUFIGNO",
            "Email": "wastecollectionltd@gmail.com",
            "Other": "I.D.129983M",
            "VatNumber": "MT 2103 8909",
            "CreditLimit": 20000,
            "Balance": -2210.56,
            "Mileage": 0,
            "DocumentNr": 0
*/
(function(){
    'use strict';

    angular.module('xoil.pages.companies.create')
        .controller('companiesCreateCtrl', companiesCreateCtrl);

    /** @ngInject */
    function companiesCreateCtrl( $scope, $http, authService, $state, toastr ) {
        $scope.data = {
            details: [
                {
                    "CompanyCode": "",
                    "Name": "",
                    "Attention": "",
                    "Address1": "",
                    "Address2": "",
                    "City": "",
                    "PostCode": "",
                    "Country": "",
                    "Tel": "",
                    "Fax": "",
                    "Mob": "",
                    "Email": "",
                    "Other": "",
                    "VatNumber": "",
                    "CreditLimit": 0,
                    "Mileage": false,
                    "DocumentNr": false                    
                }
            ],
        }

        $scope.forms = { };

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            if ( $scope.forms.details.$valid ) {
                createRecordProcessing = true;
                $http({
                    method: 'put', 
                    url: '/api/company/',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        var params = {
                            companyId: response.data.insertId, 
                        };
                        $state.go( 'companyDetails', params );                        
                        toastr.success('Created successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                    createRecordProcessing = false;
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                    createRecordProcessing = false;
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.ibuttonsearch')
        .controller('companiesIButtonSearchCtrl', companiesIButtonSearchCtrl);

    /** @ngInject */
    function companiesIButtonSearchCtrl( $scope, $http, authService, $state, toastr, companyLoaderService ) {

        $scope.forms = { };

        $scope.data = {
            ibutton: '',
        }

        var createRecordProcessing = false;
// A00000096CA2AC01
        $scope.search = function(){
            //console.log( $scope.data.ibutton );
            if( createRecordProcessing ) return
            
            if ( $scope.forms.details.$valid ) {
                createRecordProcessing = true;
                $http({
                    method: 'get', 
                    url: '/api/companies/using/Ibutton/' + $scope.data.ibutton,
                    params: {},
                    headers: {},
                    data: {}
                }).then(function success(response) {
                    if( response.data.success ){
                        if( response.data.records.length > 0 ){
                            var params = {
                                companyId: response.data.records[0]['CompanyId'],
                                accountId: response.data.records[0]['AccountId'],
                            };
                            companyLoaderService.getSelection.data.id = response.data.records[0]['CompanyId'];
                            companyLoaderService.getSelection.data.name = response.data.records[0]['CompanyName'];
                            $state.go( 'companyAccountDetails', params );                        
                            toastr.success('iButton Found');
                        } else {
                            toastr.success('iButton Not Found');
                        }
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                    createRecordProcessing = false;
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                    createRecordProcessing = false;
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.list')
        .controller('companiesListCtrl', companiesListCtrl);

    /** @ngInject */
    function companiesListCtrl( $scope, $http, authService, $state, companyLoaderService, toastr ) {

        // https://www.tutorialspoint.com/ionic/ionic_icons.htm

        $scope.data = {
            companies: [],
        };

        $scope.getCompaniesList = function(){
            var url = '/api/companies';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.companies = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }            
           
        $scope.getCompaniesList();

        $scope.fnDetails = function( item ){
            companyLoaderService.getSelection.data.id = item.id;
            companyLoaderService.getSelection.data.name = item.CompanyName;
            //$state.go( 'companies.details', { companyId: item.id } );
            $state.go( 'companyDetails', { companyId: item.id } );
            
        }

        $scope.fnAccounts = function( item ){
            companyLoaderService.getSelection.data.id = item.id;
            companyLoaderService.getSelection.data.name = item.CompanyName;
            //$state.go( 'companies.accounts', { companyId: item.id } );
            $state.go( 'companyAccounts', { companyId: item.id } );
        }

        $scope.fnPostings = function( item ){
            companyLoaderService.getSelection.data.id = item.id;
            companyLoaderService.getSelection.data.name = item.CompanyName;
            $state.go( 'companyPostings', { companyId: item.id } );
        }
    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.postpaypostingcreate')
        .controller('companiesPostPayPostingCreateCtrl', companiesPostPayPostingCreateCtrl);

    /** @ngInject */
    function companiesPostPayPostingCreateCtrl( $scope, $http, authService, $state, $stateParams, toastr, companyReportsService ) {

        $scope.forms = { };

        $scope.data = {
            details: [{
                PostingDate: companyReportsService.data.newPostPayPosting.PostingDate,
                DebitAmount: 0,
                CreditAmount: 0,
                ChitNumber: '',
                Description: '',
                DepartmentId: {},
                creditOrDebit: 'debit',
                amount: 0,
            }],
            departments: [],
        };

        $scope.forms = { };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"] + '/post-pay-posting',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.departments = response.data.records;

                    if( $scope.data.departments.length > 0 ){
                        $scope.data.details[0].DepartmentId = $scope.data.departments[0];
                        $scope.fnDeptChanged();
                    }
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();

        $scope.fnDeptChanged = function(){
            if( $scope.data.details[0].DepartmentId.isCredit ){
                $scope.data.details[0].creditOrDebit = 'credit';
            } else {
                $scope.data.details[0].creditOrDebit = 'debit';
            }            
        }        

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            if ( $scope.forms.details.$valid ) {
                createRecordProcessing = true;

                companyReportsService.data.newPostPayPosting.PostingDate = $scope.data.details[0].PostingDate;

                if( $scope.data.details[0].creditOrDebit == 'credit' ){
                    $scope.data.details[0].CreditAmount = $scope.data.details[0].amount;
                    $scope.data.details[0].DebitAmount = 0;
                } else {
                    $scope.data.details[0].DebitAmount = $scope.data.details[0].amount;
                    $scope.data.details[0].CreditAmount = 0;
                }

                $http({
                    method: 'put', 
                    url: '/api/company/' + $stateParams["companyId"] + '/post-pay-posting',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        // var params = {
                        //     companyId: $stateParams["companyId"], 
                        //     postingId: response.data.insertId, 
                        // };
                        // $state.go( 'companyPostingDetails', params );
                        $state.go( 'companyPostings', { companyId: $stateParams["companyId"] } );
                        toastr.success('Posting Created successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                    createRecordProcessing = false;
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                    createRecordProcessing = false;
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.prepaypostingcreate')
        .controller('companiesPrePayPostingCreateCtrl', companiesPrePayPostingCreateCtrl);

    /** @ngInject */
    function companiesPrePayPostingCreateCtrl( $scope, $http, authService, $state, $stateParams, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [{
                PostingDate: new Date(),
                DebitAmount: 0,
                CreditAmount: 0,
                ChitNumber: '',
                Description: '',
                creditOrDebit: 'credit',
                accounts: [],
            }],
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"] + '/pre-pay-posting',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details[0].accounts = response.data.records;

                    for( var c1=0; c1<$scope.data.details[0].accounts.length; c1++ ){
                        $scope.data.details[0].accounts[c1].amount = 0;
                    }
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();     

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            if ( $scope.forms.details.$valid ) {
                createRecordProcessing = true;

                var amount = 0;
                for( var c1=0; c1<$scope.data.details[0].accounts.length; c1++ ){
                    amount += $scope.data.details[0].accounts[c1].amount;
                }
                if( $scope.data.details[0].creditOrDebit == 'credit' ){
                    $scope.data.details[0].CreditAmount = amount;
                    $scope.data.details[0].DebitAmount = 0;
                } else {
                    $scope.data.details[0].DebitAmount = amount;
                    $scope.data.details[0].CreditAmount = 0;
                }

                $http({
                    method: 'put', 
                    url: '/api/company/' + $stateParams["companyId"] + '/pre-pay-posting',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        // var params = {
                        //     companyId: $stateParams["companyId"], 
                        //     postingId: response.data.insertId, 
                        // };
                        // $state.go( 'companyPostingDetails', params );
                        $state.go( 'companyPostings', { companyId: $stateParams["companyId"] } );
                        toastr.success('Posting Created successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                    createRecordProcessing = false;
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                    createRecordProcessing = false;
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.postingslist')
        .controller('companiesPostingsListCtrl', companiesPostingsListCtrl);

    /** @ngInject */
    function companiesPostingsListCtrl( $scope, $http, $window, authService, $state, $stateParams, companyLoaderService, toastr ) {

        companyLoaderService.ifDefaultSetId( $stateParams.companyId );

        companyLoaderService.getSelection.lastSref = 'companyPostings';

        $scope.data = {
            postings: [],
            companyId: $stateParams.companyId,
        };

        $scope.fnFormatDate = function( dt ){
            var dts = dt + '';
            return dts.substring(6,8) + '/' + dts.substring(4,6) + '/' + dts.substring(0,4)
        }

        $scope.getPostingsList = function(){
            var url = '/api/company/' + $stateParams.companyId + '/postings';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.postings = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.getPostingsList();

        $scope.fnPostingDetails = function( item ){
            $state.go( 'companyPostingDetails', { companyId: $stateParams.companyId, postingId: item.id } );
        }
       
        $scope.fnPostingPrint = function( item ){
            //$state.go( 'companyPostingDetails', { companyId: $stateParams.companyId, postingId: item.id } );

            //console.log(item);
            $window.open('/api/reports/company-posting/' + item.id);
        }
       

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.companies.postingdetails')
        .controller('companiesPostingDetailsCtrl', companiesPostingDetailsCtrl);

    /** @ngInject */
    function companiesPostingDetailsCtrl( $scope, $http, authService, $state, $stateParams, $uibModal, toastr, companyLoaderService ) {

        companyLoaderService.ifDefaultSetId( $stateParams.companyId );

        $scope.data = {
            details: [],
            departments: [],
        };

        $scope.forms = { };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/company/' + $stateParams["companyId"] + '/posting/' + $stateParams["postingId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                    $scope.data.departments = response.data.departments;

                    for( var c1=0; c1<$scope.data.departments.length; c1++ ){

                        $scope.data.departments[c1].isCredit = ( $scope.data.departments[c1].isCredit != 0 );

                        if( $scope.data.departments[c1].id == $scope.data.details[0].DepartmentId ){
                            $scope.data.details[0].DepartmentId = $scope.data.departments[c1];
                        }
                    }

                    var t1 = $scope.data.details[0].PostingDate + '';
                    $scope.data.details[0].PostingDate = new Date(
                        t1.substring(0, 4), 
                        t1.substring(4, 6) - 1, 
                        t1.substring(6, 8), 
                        0, 0, 0
                    );

                    if( $scope.data.details[0].DebitAmount != 0 ){
                        //$scope.data.details[0].isCredit = false;
                        $scope.data.details[0].creditOrDebit = 'debit';
                        $scope.data.details[0].amount = $scope.data.details[0].DebitAmount;
                    } else if( $scope.data.details[0].CreditAmount != 0 ){
                        //$scope.data.details[0].isCredit = true;
                        $scope.data.details[0].amount = $scope.data.details[0].CreditAmount;
                        $scope.data.details[0].creditOrDebit = 'credit';
                    } else {
                        //$scope.data.details[0].isCredit = $scope.data.details[0].DepartmentId.isCredit;
                        if( $scope.data.details[0].DepartmentId.isCredit ){
                            $scope.data.details[0].creditOrDebit = 'credit';
                        } else {
                            $scope.data.details[0].creditOrDebit = 'debit';
                        }

                        $scope.data.details[0].amount = 0;
                    }

                    
                    // $scope.data.departments[c1].isCredit = ( $scope.data.departments[c1].isCredit != 0 );


                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDeptChanged = function(){
            // console.log( $scope.data.details[0].DepartmentId );
            if( $scope.data.details[0].DepartmentId.isCredit ){
                $scope.data.details[0].creditOrDebit = 'credit';
            } else {
                $scope.data.details[0].creditOrDebit = 'debit';
            }            
        }

        $scope.updateRecord = function(){
            // console.log( $scope.data.details );
            if ( $scope.forms.details.$valid ) {

                if( $scope.data.details[0].creditOrDebit == 'credit' ){
                    $scope.data.details[0].CreditAmount = $scope.data.details[0].amount;
                    $scope.data.details[0].DebitAmount = 0;
                } else {
                    $scope.data.details[0].DebitAmount = $scope.data.details[0].amount;
                    $scope.data.details[0].CreditAmount = 0;
                }

                $http({
                    method: 'post', 
                    url: '/api/company/' + $stateParams["companyId"] + '/posting/' + $stateParams["postingId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'companyPostings', { companyId: $stateParams["companyId"] } );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

        // $scope.fnResetAmountTaken = function(){
        //     var modalInstance = $uibModal.open({
        //         animation: true,
        //         templateUrl: 'app/pages/companies/account-details/reset-amount-taken.html',
        //         size: 'sm',
        //     });
        //     modalInstance.result.then( function (selectedItem) {
                
        //     }, function ( command ) {
        //         if( command == 'confirm' ){
        //             $http({
        //                 method: 'post', 
        //                 url: '/api/company/' + $stateParams["companyId"] + '/account/' + $stateParams["accountId"] + '/reset-balance',
        //                 params: {},
        //                 headers: {},
        //                 data: {}
        //             }).then(function success(response) {
        //                 if( response.data.success ){
        //                     $scope.data.details[0].AmountTaken = 0;
        //                     toastr.success('Amount Taken Reset Successful!');
        //                 }else{
        //                     toastr.error('Something whent wrong!');
        //                 }
        //             }, function error( error ) {
        //                 console.log( 'error', error );
        //                 toastr.error('An Error Occured!');
        //             });
        //         }
        //     });
        // }
           
        $scope.getRecords();
        
    }

})();

/*

            "PostingId": 146172,
            "PostingTypeid": 2,
            "CompanyId": 240,
            "Accountid": 1035,
            "Attendantid": 0,
            "DepartmentId": 0,
            "PostingDate": 20190330,
            "PostingTime": 12515,
            "DebitAmount": 0,
            "CreditAmount": 50,
            "ReceiptId": 0,
            "ChitNumber": "test aaa111",
            "Description": "as above",
            "ITGPosted": 0

*/
(function(){
    'use strict';

    angular.module('xoil.pages.companies.reports')
        .controller('companiesReportsCtrl', companiesReportsCtrl);

    /** @ngInject */
    function companiesReportsCtrl( $scope, $window, $http, toastr ) {
        var today = new Date();

        $scope.companies = {
            records: [{
                "id": 0,
                "name": "All Companies"
            }],
        };

        $scope.emailFilters = {
            records: [
                {
                    "id": 0,
                    "name": "Any"
                },{
                    "id": -1,
                    "name": "Without an Email Address"
                },{
                    "id": 1,
                    "name": "Have an Email Address"
                },
            ]
        }

        var fnLoadCompanies = function(){
            $http({
                method: 'get', 
                url: '/api/companies-short',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.companies.records = [{
                        "id": 0,
                        //"code": "",
                        "name": "All Companies"
                    }];
                    response.data.records.forEach(function( company ) {
                        $scope.companies.records.push({
                            id: company.id,
                            name: company.code + ' - ' + company.name,
                        })
                    });
                }else{
                    console.log( 'issue' );
                }
            }, function error( error ) {
                console.log( 'error', error );
            });
        }

        $scope.reports = {
            debtors: {
                date: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
            },
            debtorList: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
            },
            postpayAccounts: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                company: {
                    "id": 0,
                    "name": "All Companies"
                },
                emailFilter: {
                    "id": 0,
                    "name": "Any"
                },
                balanceLessThen: 0,
                anyBalance: false,
                anyTransaction: false,
                summary: false,
                deptartmentAnalysis: false,
                statistics: false,
                emailList: false,
                emailListData: []
            },
            accounts: {
                company: {
                    "id": 0,
                    "name": "All Companies"
                },
            },
            prepayAccounts: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                company: {
                    "id": 0,
                    "name": "All Companies"
                },
            },
            transactions: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                company: {
                    "id": 0,
                    "name": "All Companies"
                },
                incTotalOfZero: false,
            },
            departments: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
            },
            companyPostings: {
                from: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                to: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
            },
            lastPayment: {
                days: 30,
            },
        }

        fnLoadCompanies();

        $scope.fnDebtors = function( mode ){
            $window.open('/api/reports/debtors/' + $scope.reports.debtors.date.toISOString() + '?format=' + mode, '_blank');
        }

        $scope.fnDebtorList = function( mode ){
            $window.open('/api/reports/debtor-list/' + $scope.reports.debtorList.from.toISOString() + '/' + $scope.reports.debtorList.to.toISOString() + '?format=' + mode, '_blank');
        }

        $scope.fnPostpayAccounts = function( mode, item ){

            if (item == undefined) {
                var companyId = $scope.reports.postpayAccounts.company.id;
            } else {
                var companyId = item.CompanyId;
            }

            var url = '/api/reports/postpay-accounts/' + 
                $scope.reports.postpayAccounts.from.toISOString() + '/' + 
                $scope.reports.postpayAccounts.to.toISOString() + '/' + 
                companyId + '/' +
                $scope.reports.postpayAccounts.balanceLessThen + '/' +
                $scope.reports.postpayAccounts.anyBalance + '/' +
                $scope.reports.postpayAccounts.anyTransaction + '/' +
                $scope.reports.postpayAccounts.summary + '/' +
                $scope.reports.postpayAccounts.deptartmentAnalysis + '/' +
                $scope.reports.postpayAccounts.statistics + '/' +
                $scope.reports.postpayAccounts.emailFilter.id + '/' +
                '?format=' + mode;
            
            if (mode == 'emailList'){
                $http({
                    method: 'get', 
                    url: url,
                    params: {},
                    headers: {},
                    data: {}
                }).then(function success(response) {
                    if( response.status == 200 ){
                        // console.log(response);
                        $scope.reports.postpayAccounts.emailListData = response.data;
                        $scope.reports.postpayAccounts.emailList = true;
                    }else{
                        console.log( 'issue' );
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            } else if (mode == 'emailListItem'){
                item.status = 1;
                $http({
                    method: 'get', 
                    url: url,
                    params: {},
                    headers: {},
                    data: {}
                }).then(function success(response) {
                    if( response.status == 200 ){
                        item.status = 2;
                    }else{
                        item.status = -1;
                    }
                }, function error( error ) {
                    item.status = -1;
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });                
            } else {
                $window.open(url, '_blank');
            }
        }

        $scope.fnAccounts = function( mode ){
            $window.open('/api/reports/accounts/'+ $scope.reports.accounts.company.id +'?format=' + mode, '_blank');
        }

        $scope.fnPrepayAccounts = function( mode ){
            $window.open(
                '/api/reports/prepay-accounts/' + 
                $scope.reports.prepayAccounts.from.toISOString() + '/' + 
                $scope.reports.prepayAccounts.to.toISOString() + '/' + 
                $scope.reports.prepayAccounts.company.id + '?format=' + mode, 
                '_blank'
            );
        }

        $scope.fnTransactions = function( mode ){
            //console.log( $scope.reports.transactions );
            $window.open(
                '/api/reports/transactions/' + 
                $scope.reports.transactions.from.toISOString() + '/' + 
                $scope.reports.transactions.to.toISOString() + '/' + 
                $scope.reports.transactions.company.id + '/' + 
                $scope.reports.transactions.incTotalOfZero + '?format=' + mode, '_blank');
        }

        $scope.fnDepartments = function( mode ){
            $window.open('/api/reports/departments/' + $scope.reports.departments.from.toISOString() + '/' + $scope.reports.departments.to.toISOString() + '?format=' + mode, '_blank');
        }        

        $scope.fnCompanyPostings = function( mode ){
            $window.open('/api/reports/company-postings/' + $scope.reports.companyPostings.from.toISOString() + '/' + $scope.reports.companyPostings.to.toISOString() + '?format=' + mode, '_blank');
        }   

        $scope.fnLastPayment = function( mode ){
            $window.open('/api/reports/last-payment-received/' + $scope.reports.lastPayment.days + '?format=' + mode, '_blank');
        }   

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.card')
        .controller('salesCardCtrl', salesCardCtrl);

    /** @ngInject */
    function salesCardCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/sales/card/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages')
        .controller('changePasswordCtrl', changePasswordCtrl);

    /** @ngInject */
    function changePasswordCtrl( $scope, $window, $http, $state, toastr ) {

        $scope.changePassword = {
            old: '',
            new1: '',
            new2: '',
        }

        $scope.changePassword = function(){
            if ( $scope.forms.details.$valid ) {

                if( $scope.changePassword.new1 != $scope.changePassword.new2 ){
                    toastr.error('New passwords do not match!');
                    return;
                }

                $http({
                    method: 'post', 
                    url: '/api/auth/change-password/',
                    params: {},
                    headers: {},
                    data: {
                        "oldPassword": $scope.changePassword.old,
                        "newPassword": $scope.changePassword.new1
                    }
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'dashboard' );
                        toastr.success('Your password has been changed');
                    }else{
                        toastr.error( response.data.message );
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });                

            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.button')
        .controller('salesButtonCtrl', salesButtonCtrl);

    /** @ngInject */
    function salesButtonCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/sales/button/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.cardbatches')
        .controller('salesCardBatchesCtrl', salesCardBatchesCtrl);

    /** @ngInject */
    function salesCardBatchesCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/card/batches/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.fueldaily')
        .controller('salesFuelDailyCtrl', salesFuelDailyCtrl);

    /** @ngInject */
    function salesFuelDailyCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';
        $scope.fields = {
            totals: [],
            currencies: [],
            decimals: {},
        }

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/fuel/daily/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    for (var key in response.data.records[0] ) {
                        if( key != 'Day' ){
                            $scope.fields.totals.push( key );
                            if( key.substring( key.length - 5 ) == 'Total' ){
                                $scope.fields.currencies.push(key);
                            }
                            if( key.substring( key.length - 6 ) == 'Litres' ){
                                $scope.fields.decimals[key] = 2;
                            }
                        }
                    }
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.cash')
        .controller('salesCashCtrl', salesCashCtrl);

    /** @ngInject */
    function salesCashCtrl( $scope, $http, authService, $timeout, $sce, $compile, dateTimeFromToService, toastr ) {

        $scope.data = {
            byOpt: [],
            byOptState: null,
            details: [],
            //detailsState: null,
        }

        $scope.dates = dateTimeFromToService.dates;

        $scope.optCallServer = function( tableState ){
            $scope.data.byOptState = tableState;
            $http({
                method: 'get', 
                url: '/api/sales/cash/opt/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.byOpt = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.detailsCallServer = function(tableState){
            //$scope.data.detailsState = tableState;
            var url = '/api/sales/cash/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString();
            // if( tableState.pagination.number != undefined ) {
            //     url += '/smart-table/' + JSON.stringify( tableState );
            // }
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                    $scope.data.details.totals = {
                        'CashIn':0,
                        'Dispensed':0,
                        'Refunded':0,
                        'Litres':0
                    };
                    for(var i = 0; i < $scope.data.details.length; i++){  
                        $scope.data.details.totals['CashIn'] += $scope.data.details[i]['CashIn'];
                        $scope.data.details.totals['Dispensed'] += $scope.data.details[i]['Dispensed'];
                        $scope.data.details.totals['Refunded'] += $scope.data.details[i]['Refunded'];
                        $scope.data.details.totals['Litres'] += $scope.data.details[i]['Litres'];
                    };  
                    //tableState.pagination.numberOfPages = response.data.noOfPages;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.detailsCallServer();

        $scope.fnSubmit = function(){
            $scope.data.byOpt = [];
            $scope.data.byOptState.pagination.start = 0;
            $scope.data.byOptState.pagination.totalItemCount = 0;
            $scope.data.byOptState.pagination.numberOfPages = 0;
            $scope.optCallServer( $scope.data.byOptState );

            $scope.data.details = [];
            // $scope.data.detailsState.pagination.start = 0;
            // $scope.data.detailsState.pagination.totalItemCount = 0;
            // $scope.data.detailsState.pagination.numberOfPages = 0;
            //$scope.detailsCallServer( $scope.data.detailsState );
            $scope.detailsCallServer();

        }

        $scope.getItemDate = function( row ){
            var tmp = row['Date'].split("/");
            tmp = new Date( tmp[2], tmp[1] - 1, tmp[0] );
            return tmp.toISOString();
        }

        // $scope.fnRefundLink = function( row, key, value ){
        //     if( row['CashIn'] > row['Dispensed'] && row['Refunded'] == 0 ){
        //         var tmp = row['Date'].split("/");;
        //         tmp = new Date( tmp[2], tmp[1] - 1, tmp[0] );
        //         return "<a ui-sref=\"sales.newrefundvrn({date:'" + tmp.toISOString() + "', dayReceiptId:" + row['Day Receipt Id'] + ",vrn:" + row['VRN'] + "})\">" + value + '</a>';
        //     }
        //     return value; 
        // }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        //$timeout( $scope.fnSubmit, 50 );
        //$scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.fuelmonthly')
        .controller('salesFuelMonthlyCtrl', salesFuelMonthlyCtrl);

    /** @ngInject */
    function salesFuelMonthlyCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';
        $scope.fields = {
            totals: [],
            currencies: [],
            decimals: {},
        }

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/fuel/monthly/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    for (var key in response.data.records[0] ) {
                        if( key != 'Month' ){
                            $scope.fields.totals.push( key );
                            if( key.substring( key.length - 5 ) == 'Total' ){
                                $scope.fields.currencies.push(key);
                            }
                            if( key.substring( key.length - 6 ) == 'Litres' ){
                                $scope.fields.decimals[key] = 2;
                            }
                        }
                    }
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.$on('$destroy', function() {
            $scope.fnDefault();
        });

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.cashinserted')
        .controller('salesCashInsertedCtrl', salesCashInsertedCtrl);

    /** @ngInject */
    function salesCashInsertedCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/cash/inserted/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.fuelyearly')
        .controller('salesFuelYearlyCtrl', salesFuelYearlyCtrl);

    /** @ngInject */
    function salesFuelYearlyCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';
        $scope.fields = {
            totals: [],
            currencies: [],
            decimals: {},
        }
        $scope.rowWithColumn = '';

        $scope.dates = dateTimeFromToService.dates;

        $scope.fnToggleRowWithColumn = function(){
            if( $scope.rowWithColumn == '' ){
                $scope.rowWithColumn = 'invert';
            } else {
                $scope.rowWithColumn = '';
            }
            $scope.fnSubmit();
        }
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/fuel/yearly/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    
                    if( $scope.rowWithColumn == 'invert' ){
                        /*
                        var template = {};
                        template[ 'Year' ] = '';
                        for( var c1=0; c1<response.data.records.length; c1++ ){
                            template[ ' ' + response.data.records[ c1 ][ 'Year' ] ] = '';
                            $scope.fields.decimals[ ' ' + response.data.records[ c1 ][ 'Year' ] ] = 2;
                        }
                        var tmp = [];
                        for (var key in response.data.records[ 0 ] ) {
                            var tmp2 = JSON.parse( JSON.stringify( template ) );
                            if( key != 'Year' ){
                                tmp2[ 'Year' ] = key;
                                for( var c1=0; c1<response.data.records.length; c1++ ){
                                    tmp2[ ' ' + response.data.records[ c1 ][ 'Year' ] ] = response.data.records[ c1 ][ key ];
                                }
                                tmp.push( tmp2 );
                            }
                        }
                        */

                        var template = {};
                        template[ 'Year' ] = '';
                        for( var c1=0; c1<response.data.records.length; c1++ ){
                            template[ response.data.records[ c1 ][ 'Year' ] + ' Total' ] = '';
                            template[ response.data.records[ c1 ][ 'Year' ] + ' Litres' ] = '';
                            $scope.fields.currencies.push( response.data.records[ c1 ][ 'Year' ] + ' Total' );
                            $scope.fields.decimals[ response.data.records[ c1 ][ 'Year' ] + ' Litres' ] = 2;
                        }

                        var tmp = [];
                        var totAndLit = [ true, true ];
                        for (var key in response.data.records[ 0 ] ) {
                            if( key != 'Year' ){
                                if( totAndLit[0] && totAndLit[1] ){
                                    //console.log( 1, key );
                                    totAndLit[0] = false;
                                    totAndLit[1] = false;
                                    var tmp2 = JSON.parse( JSON.stringify( template ) );
                                }
                                tmp2[ 'Year' ] = key;
                                for( var c1=0; c1<response.data.records.length; c1++ ){
                                    if( key.substring( key.length - 5 ) == 'Total' ){
                                        totAndLit[0] = true;
                                        tmp2[ response.data.records[ c1 ][ 'Year' ] + ' Total' ] = response.data.records[ c1 ][ key ];
                                    } else if( key.substring( key.length - 6 ) == 'Litres' ){
                                        totAndLit[1] = true;
                                        tmp2[ response.data.records[ c1 ][ 'Year' ] + ' Litres' ] = response.data.records[ c1 ][ key ];
                                    }
                                    //tmp2[ ' ' + response.data.records[ c1 ][ 'Year' ] ] = response.data.records[ c1 ][ key ];
                                }
                                if( totAndLit[0] && totAndLit[1] ){
                                    tmp.push( tmp2 );
                                }
                            }
                        }                        

                        $scope.data.records = tmp;
                        //console.log( tmp );
                    } else {

                        for (var key in response.data.records[0] ) {
                            if( key != 'Year' ){
                                $scope.fields.totals.push( key );
                                if( key.substring( key.length - 5 ) == 'Total' ){
                                    $scope.fields.currencies.push(key);
                                }
                                if( key.substring( key.length - 6 ) == 'Litres' ){
                                    $scope.fields.decimals[key] = 2;
                                }
                            }
                        }
                        $scope.data.records = response.data.records;
                    }
                    
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.$on('$destroy', function() {
            $scope.fnDefault();
        });

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.kiosk')
        .controller('salesKioskCtrl', salesKioskCtrl);

    /** @ngInject */
    function salesKioskCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/kiosk/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.manual')
        .controller('salesManualCtrl', salesManualCtrl);

    /** @ngInject */
    function salesManualCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/manual/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.newrefund')
        .controller('salesRefundNewCtrl', salesRefundNewCtrl);

    /** @ngInject */
    function salesRefundNewCtrl( $scope, $http, authService, $stateParams, $state, toastr ) {

        $scope.data = {
            records: [],
            recordsAudit: [],
        }

        $scope.title = '';
        $scope.titleAudit = 'Audit';

        $scope.date = '';
        $scope.dayReceiptId = '';
        $scope.vrn = '';

        $scope.newRefundAmount = 0;

        $scope.fnSubmitCancelRefund = function(){
            $http({
                method: 'put', 
                url: '/api/sales/refunds/' + $scope.data.records[0]['Receipt id'],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    fnLoad();
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnSubmitNewRefund = function(){
            $http({
                method: 'post', 
                url: '/api/sales/refunds/' + $scope.data.records[0]['Receipt id'] + '/' + $scope.newRefundAmount,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    fnLoad();
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnSubmit = function(){
            var params = {
                date: $scope.date.toISOString(), 
                dayReceiptId: $scope.dayReceiptId, 
                vrn: $scope.vrn 
            };
            if( $stateParams.date != undefined ){
                if( 
                    params.date != new Date( $stateParams.date ).toISOString()
                    || params.dayReceiptId != $stateParams.dayReceiptId
                    || params.vrn != $stateParams.vrn
                    ){
                    $state.go( 'sales.newrefundvrn', params );
                    return;
                }
            }
            fnLoad();
        }

        var fnLoad = function(){        

            $scope.newRefundAmount = 0;
            $scope.title = '';
            $scope.titleAudit = 'Audit';
            $scope.data.records = [];
            $scope.data.recordsAudit = [];

            $http({
                method: 'get', 
                url: '/api/sales/refunds/details/' + $scope.date.toISOString() + '/' + $scope.dayReceiptId + '/' + $scope.vrn,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';

                    if( $scope.data.records.length > 0 ){
                        $scope.newRefundAmount = Math.round( ( $scope.data.records[0]['CashIn'] - $scope.data.records[0]['Dispensed'] ) * 100, 2) / 100;
    
                        $http({
                            method: 'get', 
                            url: '/api/sales/refunds-audit/' + $scope.data.records[0]['Receipt id'],
                            params: {},
                            headers: {},
                            data: {}
                        }).then(function success(response) {
                            if( response.data.success ){
                                $scope.data.recordsAudit = response.data.records;
                                $scope.titleAudit += ' - ' + $scope.data.recordsAudit.length + ' record(s) found';
                            }else{

                            }
                        }, function error( error ) {
                            console.log( 'error', error );
                        });
                    }
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        switch( $state.current.name ){
            case 'sales.newrefundvrn':
                $scope.date = new Date( $stateParams.date );
                $scope.dayReceiptId = parseInt( $stateParams.dayReceiptId );
                $scope.vrn = parseInt( $stateParams.vrn );
                //$scope.fnSubmit();
                fnLoad();
                break;
            case 'sales.newrefundreceiptid':

                break;
            default: 
                $scope.date = new Date();
                break;
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.pump')
        .controller('salesPumpCtrl', salesPumpCtrl);

    /** @ngInject */
    function salesPumpCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/pump/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.refunds')
        .controller('salesRefundsCtrl', salesRefundsCtrl);

    /** @ngInject */
    function salesRefundsCtrl( $scope, $http, authService, $sce, $compile, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;

        $scope.fnRefundLastDays = function( days ){
            // var toDate = new Date(2018, 3, 15, 0, 0, 0, 0);
            // var fromDate = new Date(2018, 3, 15, 0, 0, 0, 0);
            var toDate = new Date();
            var fromDate = new Date();
            fromDate.setDate( toDate.getDate() - days );
            fnGetRefunds( fromDate.toISOString(), toDate.toISOString() );
        }
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];
            fnGetRefunds( $scope.dates.from.toISOString(), $scope.dates.to.toISOString() );
        }

        $scope.getTotal = function( key ){
            var total = 0;
            for( var c1=0; c1<$scope.data.records.length; c1++ ){
                total += $scope.data.records[ c1 ][ key ];
            }
            return total;
        }

        var fnGetRefunds = function( from, to ){
            $http({
                method: 'get', 
                url: '/api/sales/refunds/' + from + '/' + to,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        //$scope.fnRefundLink = function( row, key, value, scope ){
        $scope.fnRefundLink = function( row ){
            if( row['CashIn'] > row['Dispensed'] && row['Refunded'] == 0 ){
                var tmp = row['Date'].split("/");;
                tmp = new Date( tmp[2], tmp[1] - 1, tmp[0] );//.toISOString();
                //console.log( tmp );
                //var compiledVal = $compile("<a ui-sref=\"sales.newrefundvrn({date:'" + tmp.toISOString() + "', dayReceiptId:" + row['Day Receipt Id'] + ",vrn:" + row['VRN'] + "})\">" + value + '</a>')($scope);   
                // var element = document.createElement('span');
                // element.innerHTML = "<a ui-sref=\"sales.newrefundvrn({date:'" + tmp.toISOString() + "', dayReceiptId:" + row['Day Receipt Id'] + ",vrn:" + row['VRN'] + "})\">" + value + '</a>';
                // var compiledVal = $compile( element )( scope );   

                // var compiledHTML = compiledVal[0].outerHTML;
                // return compiledHTML; 
                // return $sce.trustAsHtml(compiledHTML);
                return "<a ui-sref=\"sales.newrefundvrn({date:'" + tmp.toISOString() + "', dayReceiptId:" + row['Day Receipt Id'] + ",vrn:" + row['VRN'] + "})\">" + row['Refunded'] + '</a>';
            }
            return row['Refunded']; 
        }        

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.refundsaudit')
        .controller('salesRefundsAuditCtrl', salesRefundsAuditCtrl);

    /** @ngInject */
    function salesRefundsAuditCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/refunds-audit/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.tagging')
        .controller('salesTaggingCtrl', salesTaggingCtrl);

    /** @ngInject */
    function salesTaggingCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            byAttendand: [],
            details: [],
        }

        $scope.titleAttendant = 'By Attendant';
        $scope.titleDetails = 'Details';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.titleAttendant = 'By Attendant';
            $scope.titleDetails = 'Details';
            
            $scope.data.byAttendand = [];
            $scope.data.details = [];
                        
            $http({
                method: 'get', 
                url: '/api/sales/tagging/attendant/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.byAttendand = response.data.records;
                    $scope.titleAttendant = 'By Attendant - ' + $scope.data.byAttendand.length + ' record(s) found';
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

            $http({
                method: 'get', 
                url: '/api/sales/tagging/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                    $scope.titleDetails = 'Details - ' + $scope.data.details.length + ' record(s) found';
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.tank')
        .controller('salesTankCtrl', salesTankCtrl);

    /** @ngInject */
    function salesTankCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            records: [],
        }

        $scope.title = '';

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.fnSubmit = function(){
            $scope.title = '';
            $scope.data.records = [];

            $http({
                method: 'get', 
                url: '/api/sales/tank/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                    $scope.title = $scope.data.records.length + ' record(s) found';
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.departments')
        .controller('stationDepartmentsCtrl', stationDepartmentsCtrl);

    /** @ngInject */
    function stationDepartmentsCtrl( $scope, $http ) {
        $scope.data = {
            list: [],
        };

        $scope.getList = function(){
            var url = '/api/departments';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.list = response.data.records;

                    for( var c1=0; c1<$scope.data.list.length; c1++ ){
                        if( $scope.data.list[c1].defaultcredit == 1 ){
                            $scope.data.list[c1].default = 'Credit';
                        }else{
                            $scope.data.list[c1].default = 'Debit';
                        }
                    }
                }
            }, function error( error ) {
                console.log( 'error', error );
            });

        }

        $scope.getList();
    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.sales.total')
        .controller('salesTotalCtrl', salesTotalCtrl);

    /** @ngInject */
    function salesTotalCtrl( $scope, $http, authService, dateTimeFromToService, toastr ) {

        $scope.data = {
            byOpt: [],
            byType: [],
            byAttendand: [],
        }

        $scope.dates = dateTimeFromToService.dates;
        
        $scope.optCallServer = function( tableState ){
            $scope.data.byOptState = tableState;
            $http({
                method: 'get', 
                url: '/api/sales/cash/opt/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.byOpt = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnSubmit = function(){
            $scope.data.byOpt = [];
            $scope.data.byType = [];
            $scope.data.byAttendand = [];

            $scope.optCallServer();

            $http({
                method: 'get', 
                url: '/api/sales/total/type/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.byType = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

            $http({
                method: 'get', 
                url: '/api/sales/total/attendant/' + $scope.dates.from.toISOString() + '/' + $scope.dates.to.toISOString(),
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.byAttendand = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnDefault = function(){
            dateTimeFromToService.default();
        }

        $scope.fnSubmit();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.departmentcreate')
        .controller('stationDepartmentCreateCtrl', stationDepartmentCreateCtrl);

    /** @ngInject */
    function stationDepartmentCreateCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [{  
                "Code":"",
                "Name":"",
                "defaultcredit": 0,
                "default":  { name: 'Debit' },
            }],
            defaults: [
                { name: 'Debit' },
                { name: 'Credit' },
            ]
        };

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return

            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'put', 
                    url: '/api/department',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.departments' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.departmentdetails')
        .controller('stationDepartmentDetailsCtrl', stationDepartmentDetailsCtrl);

    /** @ngInject */
    function stationDepartmentDetailsCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [],
            defaults: [
                { name: 'Debit' },
                { name: 'Credit' },
            ]
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/department/' + $stateParams["departmentId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;

                    if( $scope.data.details[0].DefaultCredit == 1 ){
                        $scope.data.details[0].default = $scope.data.defaults[1];
                    }else{
                        $scope.data.details[0].default = $scope.data.defaults[0];
                    }

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.getRecords();  


        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/department/' + $stateParams["departmentId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.departments' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.fuelpurchases')
        .controller('stationFuelPurchasesCtrl', stationFuelPurchasesCtrl);

    /** @ngInject */
    function stationFuelPurchasesCtrl( $scope, $http, authService, $window, toastr ) {
        $scope.data = {
            list: [],
        };

        $scope.pageSize = 20;

        $scope.getList = function(){
            var url = '/api/fuel-purchases';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.list = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getList();

        $scope.fnGetFuelReport = function( id, mode ){
            $window.open('/api/fuel-purchase-document/' + id + '?format=' + mode, '_blank');
        }        
    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.details')
        .controller('stationDetailsCtrl', stationDetailsCtrl);

    /** @ngInject */
    function stationDetailsCtrl( $scope, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [],
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/station-details',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();  


        $scope.updateRecord = function(){
            // console.log( $scope.data.details );
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/station-details',
                    params: {},
                    headers: {},
                    data: { records: $scope.data.details }
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.fuelpurchaseCreate')
        .controller('stationFuelPurchaseCreateCtrl', stationFuelPurchaseCreateCtrl);

    /** @ngInject */
    function stationFuelPurchaseCreateCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [{
                SupplierId: {},
                Document: '',
                Operator: '',
                Truck: '',
                Seals: 0,
                DeliveryDateTime: new Date(),
                DepartedDateTime: new Date(),
                Cheque: '',
                Amount: 0,
                tanks: [],
                //DeliveryTime: 0,
                //DeliveryDeparted: 0,
                //DeliveryDate: 0,

                //TankId: 0,
                //Litres: 0,
                //costprice: 0,
                //vat : 0,
                //sellprice: 0,
                //vatcostprice: 0,
                //vatsellprice: 0,
            }],
            suppliers: [],
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/fuel-purchase-prepare',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.suppliers = response.data.suppliers;
                    $scope.data.details[0].tanks = response.data.tanks;

                    if( $scope.data.suppliers.length > 0 ){
                        $scope.data.details[0].SupplierId = $scope.data.suppliers[0];
                    }

                    for( var c1=0; c1< $scope.data.details[0].tanks.length; c1++ ){
                        $scope.data.details[0].tanks[c1]['Litres'] = 0;
                        $scope.data.details[0].tanks[c1]['Cost'] = 0;
                        $scope.data.details[0].tanks[c1]['VATCost'] = 0;
                        $scope.data.details[0].tanks[c1]['Selling'] = 0;
                    }
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'put', 
                    url: '/api/fuel-purchase',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0],
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.fuelpurchases' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.pumpscalibrate')
        .controller('stationPumpsCalibrateCtrl', stationPumpsCalibrateCtrl);

    /** @ngInject */
    function stationPumpsCalibrateCtrl( $scope, $http, authService, $state, toastr ) {

        $scope.data = {
            records: [],
            lastPump: -1,
        }

        $scope.fnLoad = function(){
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/pumps',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                }else{

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });
        }

        $scope.fnLoad();

        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/pumps',
                    params: {},
                    headers: {},
                    data: { records: $scope.data.records }
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.pumps' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.receiptsfooters')
        .controller('receiptFootersCtrl', receiptFootersCtrl);

    /** @ngInject */
    function receiptFootersCtrl( $scope, $http ) {
        $scope.data = {
            list: [],
        };

        $scope.getList = function(){
            var url = '/api/receipt-footer';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.list = response.data.records;
                }
            }, function error( error ) {
                console.log( 'error', error );
            });

        }

        $scope.getList();

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.pumps')
        .controller('stationPumpsCtrl', stationPumpsCtrl);

    /** @ngInject */
    function stationPumpsCtrl( $scope, $http ) {

        $scope.data = {
            records: [],
            lastPump: -1,
        }

        $scope.fnLoad = function(){
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/pumps',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                }else{

                }
            }, function error( error ) {
                console.log( 'error', error );
            });
        }

        $scope.fnLoad();

        // $scope.setLastPump = function( item ){
        //     console.log( item );
        //     $scope.data.lastPump = item.pumpid;
        //     return $scope.data.lastPump;
        // }

    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.fuelrates')
        .controller('stationFuelRatesCtrl', stationFuelRatesCtrl);

    /** @ngInject */
    function stationFuelRatesCtrl( $scope, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            records: [],
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/fuel-rates',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();  

        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/fuel-rates',
                    params: {},
                    headers: {},
                    data: { records: $scope.data.records }
                }).then(function success(response) {
                    if( response.data.success ){
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }
    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.receiptsfooterscreate')
        .controller('stationReceiptsFootersCreateCtrl', stationReceiptsFootersCreateCtrl);

    /** @ngInject */
    function stationReceiptsFootersCreateCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [{  
                "Line1":"",
                "Line2":"",
                "Line3":"",
                "FromDate": new Date(),
                "ToDate": new Date(),
            }],
        };

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return

            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'put', 
                    url: '/api/receipt-footer',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.footers' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.receiptsfootersdetails')
        .controller('stationReceiptsFootersDetailsCtrl', stationReceiptsFootersDetailsCtrl);

    /** @ngInject */
    function stationReceiptsFootersDetailsCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [],
        };

        $scope.getRecords = function(){
            console.log( 123 );
            $http({
                method: 'get', 
                url: '/api/receipt-footer/' + $stateParams["footerId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;

                    var t1 = $scope.data.details[0].FromDate + '';
                    $scope.data.details[0].FromDate = new Date(
                        t1.substring(0, 4), 
                        t1.substring(4, 6) - 1, 
                        t1.substring(6, 8), 
                        0, 0, 0
                    );

                    var t1 = $scope.data.details[0].ToDate + '';
                    $scope.data.details[0].ToDate = new Date(
                        t1.substring(0, 4), 
                        t1.substring(4, 6) - 1, 
                        t1.substring(6, 8), 
                        0, 0, 0
                    );                    

                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();  


        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/receipt-footer/' + $stateParams["footerId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.footers' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.suppliers')
        .controller('stationSuppliersCtrl', stationSuppliersCtrl);

    /** @ngInject */
    function stationSuppliersCtrl( $scope, $http ) {
        $scope.data = {
            list: [],
        };

        $scope.getList = function(){
            var url = '/api/suppliers';
            $http({
                method: 'get', 
                url: url,
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.list = response.data.records;
                }
            }, function error( error ) {
                console.log( 'error', error );
            });

        }

        $scope.getList();
    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.suppliercreate')
        .controller('stationSupplierCreateCtrl', stationSupplierCreateCtrl);

    /** @ngInject */
    function stationSupplierCreateCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [{
                Address1: '',
                Address2: '',
                Attention: '',
                City: '',
                CompanyCode: '',
                Country: '',
                Email: '',
                Fax: '',
                Mob: '',
                Name: '',
                Other: '',
                PostCode: '',
                Tel: '',
                VatNumber: "",
            }],
        };

        var createRecordProcessing = false;

        $scope.createRecord = function(){
            if( createRecordProcessing ) return
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'put', 
                    url: '/api/supplier/',
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.suppliers' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.supplierdetails')
        .controller('stationSupplierDetailsCtrl', stationSupplierDetailsCtrl);

    /** @ngInject */
    function stationSupplierDetailsCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            details: [],
        };

        $scope.getRecords = function(){
            $http({
                method: 'get', 
                url: '/api/supplier/' + $stateParams["supplierId"],
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.details = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });;

        }

        $scope.getRecords();  


        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/supplier/' + $stateParams["supplierId"],
                    params: {},
                    headers: {},
                    data: $scope.data.details[0]
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.suppliers' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.tanks')
        .controller('stationTanksCtrl', stationTanksCtrl);

    /** @ngInject */
    function stationTanksCtrl( $scope, $http ) {

        $scope.data = {
            records: [],
        }

        $scope.fnLoad = function(){
            $scope.data.records = [];
            
            $http({
                method: 'get', 
                url: '/api/tanks/',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                }else{

                }
            }, function error( error ) {
                console.log( 'error', error );
            });
        }

        $scope.round = function(a){
            a = Math.round( a );
            return a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        $scope.getY = function(t){ // 0 - 130
            return ( ( t.free / t.capacity ) ) * 130
        }

        $scope.getHeight = function(t){
            return 130 - $scope.getY(t);
        }

        $scope.fnCalibrate = function(){
            console.log( 'TBD' )
        }

        $scope.fnLoad();

    }
})();
(function(){
    'use strict';

    angular.module('xoil.pages.station.tankscalibrate')
        .controller('stationTanksCalibrateCtrl', stationTanksCalibrateCtrl);

    /** @ngInject */
    function stationTanksCalibrateCtrl( $scope, $state, $stateParams, $http, authService, toastr ) {

        $scope.forms = { };

        $scope.data = {
            records: [],
        };

        $scope.getRecords = function(){
            console.log( 123 );
            $http({
                method: 'get', 
                url: '/api/tanks/calibrate',
                params: {},
                headers: {},
                data: {}
            }).then(function success(response) {
                if( response.data.success ){
                    $scope.data.records = response.data.records;
                }
            }, function error( error ) {
                if( error.status == 401 ){
                    authService.loggedOut();
                }else{
                    console.log("error", error);
                    toastr.error('An Error Occured!');
                }
            });

        }

        $scope.getRecords();  


        $scope.updateRecord = function(){
            
            if ( $scope.forms.details.$valid ) {

                $http({
                    method: 'post', 
                    url: '/api/tanks/calibrate',
                    params: {},
                    headers: {},
                    data: { records: $scope.data.records }
                }).then(function success(response) {
                    if( response.data.success ){
                        $state.go( 'station.tanks' );
                        toastr.success('Saved successfully!');
                    }else{
                        toastr.error('Something whent wrong!');
                    }
                }, function error( error ) {
                    if( error.status == 401 ){
                        authService.loggedOut();
                    }else{
                        console.log("error", error);
                        toastr.error('An Error Occured!');
                    }
                });
            }
        }


    }

})();


/*

        {
            "tankid": 1,
            "fuelname": "ED",
            "litresintank": 8226.61,
            "fuelcolor": "444444"
        },

*/
(function () {
    'use strict';

    angular.module('xoil.components')
        .directive('textFormComponent', textFormComponent);

    /** @ngInject */
    function textFormComponent() {
        //console.log(1);
        return {
            restrict: 'E',
            //controller: 'textFormComponentCtrl',
            templateUrl: 'app/components/form-fields/text/template.html',
            transclude: true,
            scope: {
                label: '=',
                value: '=',
                placeholder: '=',
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/auto-data-table/auto-data-table.html','<div ba-panel="" ba-panel-title="{{ heading }}" ba-panel-class="with-scroll"><div ng-if="(!pagingEnabled && data.length>0) || pagingEnabled || server"><table class="table table-striped autoDataTable" st-pipe="server" st-table="data"><thead><tr><th ng-repeat="(key, value) in data[0] track by $index" ng-style="getStyle(key, value)"><span ng-if="!headersBreakLine">{{ key }}</span> <span ng-if="headersBreakLine" ng-bind-html="key.replace( \' \', \'<br />\' )"></span></th></tr></thead><tbody><tr ng-repeat="row in data track by $index"><td ng-repeat="(key, value) in row track by $index" ng-style="getStyle(key, value)" bind-html-compile="processValue( row, key, value )"></td></tr><tr ng-if="totals != undefined"><td ng-repeat="(key, value) in data[0] track by $index" class="totals" style="text-align:right;">{{ getTotal( key ) }}</td></tr></tbody><tfoot ng-if="pagingEnabled"><tr><td colspan="{{ pagingColSpan }}" class="text-center"><div st-pagination="" st-items-by-page="pageSize" st-displayed-pages="5"></div><button ng-click="fnTest();">Test</button></td></tr></tfoot></table></div></div>');
$templateCache.put('app/components/admin-options/reset-accounts-in-use.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to reset the accounts in use?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-primary" ng-click="$dismiss(\'confirm\');">Reset Accounts in Use</button></div></div>');
$templateCache.put('app/components/admin-options/reset-pumps.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to reset the pumps?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-danger" ng-click="$dismiss(\'confirm\');">Reset Pumps</button></div></div>');
$templateCache.put('app/components/admin-options/reset-system.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to reset the system?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-danger" ng-click="$dismiss(\'confirm\');">Reset System</button></div></div>');
$templateCache.put('app/components/admin-options/shutdown-halt.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to turn off the system?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-danger" ng-click="$dismiss(\'confirm\');">Shutdown</button></div></div>');
$templateCache.put('app/components/admin-options/shutdown-restart.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to restart the system?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-danger" ng-click="$dismiss(\'confirm\');">Restart</button></div></div>');
$templateCache.put('app/components/admin-options/template.html','<div ba-panel="" ba-panel-title="Reset Options" ba-panel-class="with-scroll" class="col-md-6"><div><button ng-click="fnResetSystem()" type="button" class="btn btn-danger">System</button> <button ng-click="fnResetPumps()" type="button" class="btn btn-danger">Pumps</button> <button ng-click="fnResetAccountsInUse()" type="button" class="btn btn-primary">Accounts In use</button></div></div>');
$templateCache.put('app/components/company-loader/template.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Company" ba-panel-class="with-scroll"><div style="margin: 0 -15px 0 -15px;"><div class="col-md-6"><div class="form-group"><ui-select ng-model="selectedCompany.data" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" on-select="fnOnSelect($item)" search-enabled="true"><ui-select-match placeholder="Search Company">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="company in companies.records | filter: $select.search"><span ng-bind-html="company.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-6"><button class="btn btn-primary ion-information" ui-sref="companyDetails({ companyId: selectedCompany.data[\'id\'] })">&nbsp;&nbsp;Details</button> <button class="btn btn-info ion-ios-people" ui-sref="companyAccounts({ companyId: selectedCompany.data[\'id\'] })">&nbsp;&nbsp;Accounts</button> <button class="btn btn-success ion-ios-cart" ui-sref="companyPostings({ companyId: selectedCompany.data[\'id\'] })">&nbsp;&nbsp;Postings</button></div></div></div></div></div>');
$templateCache.put('app/components/date-time-from-to/date-time-from-to.html','<form class="row form-inline"><div class="form-group col-xs-8 col-sm-3 col-md-2 col-lg-2 col-xl-2"><label>From</label><date-component value="fromDateTime"></date-component></div><div class="form-group col-xs-4 col-sm-2 col-md-2 col-lg-2 col-xl-1"><time-component value="fromDateTime" style="margin-top: -10px;"></time-component></div><div class="form-group col-xs-8 col-sm-3 col-md-2 col-lg-2 col-xl-2"><label>To</label><date-component value="toDateTime"></date-component></div><div class="form-group col-xs-4 col-sm-2 col-md-2 col-lg-2 col-xl-1"><time-component value="toDateTime"></time-component></div><div class="form-group col-sm-4 col-md-4 col-lg-3 col-xl-2"><button type="submit" class="btn btn-primary" ng-click="submit()">Submit</button> <button type="default" class="btn btn-info" ng-click="default()">Default</button> <button type="default" class="btn btn-secondary" onclick="window.print();">Print</button></div></form>');
$templateCache.put('app/components/last-transaction/new-kiosk-sale.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Kiosk Sale Amount</h4></div><div class="modal-body"><input type="number" class="form-control" step="0.01" ng-model="amount" autofocus=""></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-success" ng-click="$dismiss( amount );">Confirm</button></div></div>');
$templateCache.put('app/components/last-transaction/template.html','<div ba-panel="" ba-panel-title="Pumps" ba-panel-class="with-scroll" class="col-lg-12"><div><table class="table table-striped mtx"><tr><th>Pump</th><th>Status</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th></tr><tr ng-repeat="dt in mtx.data track by $index"><td><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">{{ dt.pumpname }}<span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="" ng-click="fnNewKioskSale( dt.pumpid )">Kiosk Sale</a></li><li role="separator" class="divider"></li><li><a href="" ng-click="fnPumpTurnOn( dt.pumpid )">Turn On</a></li><li role="separator" class="divider"></li><li><a href="" ng-click="fnPumpTurnOff( dt.pumpid )">Turn Off</a></li></ul></div></td><td class="txMode{{ dt.statusmode }}">{{ dt.status }}</td><td class="txMode{{ dt.t1mode }}">{{ dt.t1value | number : 2 }}</td><td class="txMode{{ dt.t2mode }}">{{ dt.t2value | number : 2 }}</td><td class="txMode{{ dt.t3mode }}">{{ dt.t3value | number : 2 }}</td><td class="txMode{{ dt.t4mode }}">{{ dt.t4value | number : 2 }}</td><td class="txMode{{ dt.t5mode }}">{{ dt.t5value | number : 2 }}</td><td class="txMode{{ dt.t6mode }}">{{ dt.t6value | number : 2 }}</td><td class="txMode{{ dt.t7mode }}">{{ dt.t7value | number : 2 }}</td><td class="txMode{{ dt.t8mode }}">{{ dt.t8value | number : 2 }}</td><td class="txMode{{ dt.t9mode }}">{{ dt.t9value | number : 2 }}</td><td class="txMode{{ dt.t10mode }}">{{ dt.t10value | number : 2 }}</td></tr></table><table class="table"><tr><td>Sale Modes</td><td class="txMode1">Cash</td><td class="txMode2">Manual</td><td class="txMode3">Tagging</td><td class="txMode4">Button</td><td class="txMode5">Bank</td></tr></table><br><p>Last Updated: {{ mtx.lastSuccess }}</p></div></div>');
$templateCache.put('app/components/last-transaction/turn-off-modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to turn off this pump?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-danger" ng-click="$dismiss(\'confirm\');">Turn Off</button></div></div>');
$templateCache.put('app/components/last-transaction/turn-on-modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to turn on this pump?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-success" ng-click="$dismiss(\'confirm\');">Turn On</button></div></div>');
$templateCache.put('app/components/date/date.html','<p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="value" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p>');
$templateCache.put('app/components/operation-mode/template.html','<div ba-panel="" ba-panel-title="Operation Mode" ba-panel-class="with-scroll" class="col-md-6"><div ng-show="!om.loaded">Loading please wait.</div><div ng-show="om.loaded"><p>Current Mode: <strong>{{ om.mode }}</strong>.</p><div ng-show="!om.updating"><div ng-if="om.screen==0"><button ng-click="changeScreen(1);" type="button" class="btn btn-warning">Change Mode</button></div><div ng-if="om.screen==1"><button ng-if="om.mode!=\'scheduler\'" ng-click="changeMode(\'scheduler\');" type="button" class="btn btn-primary">Scheduler Mode</button> <button ng-if="om.mode!=\'automatic\'" ng-click="changeMode(\'automatic\');" type="button" class="btn btn-primary">Automatic Mode</button> <button ng-if="om.mode!=\'tagging\'" ng-click="changeMode(\'tagging\');" type="button" class="btn btn-primary">Tagging Mode</button> <button ng-if="om.mode!=\'manual\'" ng-click="changeMode(\'manual\');" type="button" class="btn btn-primary">Manual Mode</button></div><div ng-if="om.screen==2"><div ng-if="om.needPassword">Password required: <input type="text" ng-model="om.modePassword"> <button ng-click="confirmMode();" type="button" class="btn btn-primary">Confirm</button> <button ng-click="changeScreen(0);" type="button" class="btn btn-info">Cancel</button></div><div ng-if="!om.needPassword">Please click <button ng-click="confirmMode();" type="button" class="btn btn-primary">{{ om.modeSelected }}</button> again to confirm or <button ng-click="changeScreen(0);" type="button" class="btn btn-info">cancel</button> to reset.</div></div><div ng-if="om.screen==3">Switching Mode. Please wait.</div></div></div></div>');
$templateCache.put('app/components/slave-status/template.html','<div ba-panel="" ba-panel-title="Replication Status" class="col-md-12"><div ng-show="!ss.loaded">Loading please wait.</div><div ng-show="ss.loaded"><p class="col-sm-4 col-xs-4" ng-show="ss.configured" style="color:#009900;"><i class="ion-checkmark-round">Configured</i></p><p class="col-sm-4 col-xs-4" ng-show="!ss.configured" style="color:#990000;"><i class="ion-close-round">Configured</i></p><p class="col-sm-4 col-xs-4" ng-show="ss.connected" style="color:#009900;"><i class="ion-checkmark-round">Connected</i></p><p class="col-sm-4 col-xs-4" ng-show="!ss.connected" style="color:#990000;"><i class="ion-close-round">Connected</i></p><p class="col-sm-4 col-xs-4" ng-show="ss.running" style="color:#009900;"><i class="ion-checkmark-round">Running</i></p><p class="col-sm-4 col-xs-4" ng-show="!ss.running" style="color:#990000;"><i class="ion-close-round">Running</i></p></div></div>');
$templateCache.put('app/components/time/time.html','<div uib-timepicker="" ng-model="value" hour-step="hstep" minute-step="mstep" show-meridian="ismeridian"></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div><div class="row"></div><div class="row"><last-transaction class="printSection"></last-transaction></div><div class="row"><operation-mode></operation-mode><admin-options></admin-options></div><div class="row"><slave-status></slave-status></div></div>');
$templateCache.put('app/components/form-fields/text/template.html','<label for="input{{$id}}">{{ label }}</label> <input type="text" class="form-control" id="input{{$id}}" placeholder="{{ placeholder }}" ng-model="value" required="">');
$templateCache.put('app/pages/attendants/create/template.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Personal Information" ba-panel-class="with-scroll"><form name="forms.details" id="forms.details"><div ng-include="\'app/pages/attendants/details/detailsFormFields.html\'"></div><div class="row" style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="createAttendant()">Create Attendant</button></div></form></div></div></div>');
$templateCache.put('app/pages/attendants/details/detailsForm.html','<form name="forms.details" id="forms.details"><div ng-include="\'app/pages/attendants/details/detailsFormFields.html\'"></div><div class="row" style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="saveDetails()">Save Personal Details</button></div></form>');
$templateCache.put('app/pages/attendants/details/detailsFormFields.html','<div class="form-group"><label for="input01">Name</label> <input type="text" class="form-control" id="input01" placeholder="" ng-model="data.detailsRecords[0].Name" required=""></div><div class="form-group"><label for="input02">Surname</label> <input type="text" class="form-control" id="input02" placeholder="" ng-model="data.detailsRecords[0].Surname"><div class="form-group"><label for="input03">ID Number</label> <input type="text" class="form-control" id="input03" placeholder="" ng-model="data.detailsRecords[0].IdNumber"></div><div class="form-group"><label for="input04">NI Number</label> <input type="text" class="form-control" id="input04" placeholder="" ng-model="data.detailsRecords[0].NiNumber"></div><div class="form-group"><label for="input05">Address Line 1</label> <input type="text" class="form-control" id="input05" placeholder="" ng-model="data.detailsRecords[0].Address1"></div><div class="form-group"><label for="input06">Address Line 2</label> <input type="text" class="form-control" id="input06" placeholder="" ng-model="data.detailsRecords[0].Address2"></div><div class="form-group"><label for="input07">City</label> <input type="text" class="form-control" id="input07" placeholder="" ng-model="data.detailsRecords[0].City"></div><div class="form-group"><label for="input08">Post Code</label> <input type="text" class="form-control" id="input08" placeholder="" ng-model="data.detailsRecords[0].PostCode"></div><div class="form-group"><label for="input09">Father\'s Name</label> <input type="text" class="form-control" id="input09" placeholder="" ng-model="data.detailsRecords[0].FatherName"></div><div class="form-group"><label for="input10">Telephone</label> <input type="text" class="form-control" id="input10" placeholder="" ng-model="data.detailsRecords[0].Tel"></div><div class="form-group"><label for="input11">Fax</label> <input type="text" class="form-control" id="input11" placeholder="" ng-model="data.detailsRecords[0].Fax"></div><div class="form-group"><label for="input12">Mobile</label> <input type="text" class="form-control" id="input12" placeholder="" ng-model="data.detailsRecords[0].Mob"></div><div class="form-group"><label for="input13">Email</label> <input type="text" class="form-control" id="input13" placeholder="" ng-model="data.detailsRecords[0].Email"></div><div class="form-group"><label for="input14">Other</label> <input type="text" class="form-control" id="input14" placeholder="" ng-model="data.detailsRecords[0].Other"></div><div class="form-group"><label>Employment Date</label><date-component value="data.detailsRecords[0].EmploymentDate"></date-component></div><div class="form-group"><label for="input16">Terminated</label> <input type="checkbox" id="input14" ng-model="data.detailsRecords[0].Terminated" style="margin:5px 0 0 10px;"></div><div class="form-group" ng-if="data.detailsRecords[0].Terminated"><label for="input17">Termination Date</label><date-component value="data.detailsRecords[0].TerminationDate"></date-component></div></div>');
$templateCache.put('app/pages/attendants/details/iButtonsForm.html','<div class="row"><div class="col-xs-6 col-sm-6"><label class="nowrap"><span>iButton</span></label></div><div class="col-xs-3 col-sm-3"><label class="nowrap"><span>Limit</span></label></div><div class="col-xs-3 col-sm-3"><label class="nowrap"><span></span></label></div></div><div class="row" ng-repeat="record in data.ibuttonsRecords track by $index" style="padding-top: 5px;"><div class="col-xs-6 col-sm-6">{{ record.ibuttonid }}</div><div class="col-xs-3 col-sm-3">{{ record.salelimit }}</div><div class="col-xs-3 col-sm-3"><button ng-click="deleteIButton( record.ibuttonid );">Delete</button></div></div><form style="margin-top: 10px;" name="forms.ibuttons" id="forms.ibuttons"><div class="form-group"><label for="input01">New iButton</label> <input type="text" class="form-control" id="input01" placeholder="" ng-model="iButton.newIButton" required=""></div><div class="form-group"><label for="input02">Sale Limit</label> <input type="number" class="form-control" id="input02" placeholder="" ng-model="iButton.newIButtonLimit" required=""></div><div class="row" style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="saveIButtons()">Save New Button</button></div></form>');
$templateCache.put('app/pages/attendants/details/template.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Personal Information" ba-panel-class="with-scroll"><div ng-include="\'app/pages/attendants/details/detailsForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Time Table" ba-panel-class="with-scroll"><div ng-include="\'app/pages/attendants/details/timeTableForm.html\'"></div></div><div ba-panel="" ba-panel-title="Tagging Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/attendants/details/iButtonsForm.html\'"></div></div></div></div>');
$templateCache.put('app/pages/attendants/details/timeTableForm.html','<form name="forms.timeTable" id="forms.timeTable"><div class="row"><div class="col-xs-6 col-sm-2"><label class="nowrap"><span>Day</span></label></div><div class="col-xs-6 col-sm-2"><label class="nowrap"><span>Service</span></label></div><div class="col-xs-6 col-sm-4"><label class="nowrap"><span>Start</span></label></div><div class="col-xs-6 col-sm-4"><label class="nowrap"><span>End</span></label></div></div><div class="row" ng-repeat="record in data.timetableRecords track by $index" style="border-top: 1px dashed #ccc; padding-top: 10px;"><div class="col-xs-6 col-sm-2">{{ record.dayno }}</div><div class="col-xs-6 col-sm-2"><input type="checkbox" ng-model="record.services"></div><div class="col-xs-6 col-sm-4"><time-component value="record.starttime"></time-component></div><div class="col-xs-6 col-sm-4"><time-component value="record.endtime"></time-component></div></div><div class="row" style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="saveTimeTable()">Save Time Table</button></div></form>');
$templateCache.put('app/pages/attendants/list/template.html','<auto-data-table-component heading="title" data="data.records" functions="{Details:fnDetailsLink}" styles="{\'Details\':\'center\'}" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/companies/account-details/detailsFormFields.html','<div class="row"><div class="col-md-6"><div class="form-group"><label for="">Account Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].AccountCode" required=""></div><div class="form-group"><label for="">Client Name</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].ClientName" required=""></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Balance</label><div class="col-xs-8 col-sm-10"><b ng-if="data.details[0].AccountTypeID.id == 1">{{ data.details[0].PrePaidInAc | number:2 }}</b> <b ng-if="data.details[0].AccountTypeID.id == 2">{{ data.details[0].AmountTaken | number:2 }}</b> <button type="submit" class="status-button btn btn-xs btn-warning" ng-click="fnResetAmountTaken();" style="margin-left: 10px;">RESET</button></div></div><div class="form-group"><label for="">Allowed Fuel</label><ui-select ng-model="data.details[0].FuelId" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Fuel">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="fuel in data.fuels"><span ng-bind-html="fuel.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="">Limit Period</label><ui-select ng-model="data.details[0].LimitPeriodID" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Period">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="period in data.periods"><span ng-bind-html="period.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="">Limit Amount</label> <input type="number" step="0.01" class="form-control" placeholder="" ng-model="data.details[0].LimitAmount" required=""></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Request Mileage</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].MileageRequired"></div></div><div class="form-group"><label for="">Pin</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Pin" maxlength="4" size="4" required=""></div><div class="form-group"><label for="">iButton</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].iButtonID"></div></div><div class="col-md-6"><div class="form-group"><label for="">Issued Date</label><date-component value="data.details[0].Issued"></date-component></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Holidays</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].PublicHolidays"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Monday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Monday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Tuesday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Tuesday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Wednesday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Wednesday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Thursday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Thursday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Friday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Friday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Saturday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Saturday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Sunday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Sunday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important"><label for="" class="col-sm-2 control-label">From Time</label><div class="col-sm-4"><time-component value="data.details[0].FromTime" style="margin-top: 0px;"></time-component></div><label for="" class="col-sm-2 control-label">To Time</label><div class="col-sm-4"><time-component value="data.details[0].ToTime" style="margin-top: 0px;"></time-component></div></div><div class="form-group" style="clear:both;margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Has Expired</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].hasExpired"></div></div><div class="form-group" ng-if="data.details[0].hasExpired" style="margin: 0 -15px 0 -15px !important;"><label for="" class="col-sm-2 control-label">Expiry Date</label><div class="col-sm-10"><date-component value="data.details[0].Expired"></date-component></div></div></div></div>');
$templateCache.put('app/pages/companies/account-details/reset-amount-taken.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Confirmation Required</h4></div><div class="modal-body">Are you sure you want to reset this account?</div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$dismiss()">Cancel</button> <button type="button" class="btn btn-success" ng-click="$dismiss(\'confirm\');">Confirm</button></div></div>');
$templateCache.put('app/pages/companies/account-details/template.html','<company-loader-component class="printRemove"></company-loader-component><form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/account-details/detailsFormFields.html\'"></div><div style="text-align: center;" class="printRemove"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Account Details</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/account-create/detailsFormFields.html','<div class="row"><div class="col-md-6"><div class="form-group"><label for="">Account Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].AccountCode" required=""></div><div class="form-group"><label for="">Client Name</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].ClientName" required=""></div><div class="form-group"><label for="">Allowed Fuel</label><ui-select ng-model="data.details[0].FuelId" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Fuel">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="fuel in data.fuels"><span ng-bind-html="fuel.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="">Limit Period</label><ui-select ng-model="data.details[0].LimitPeriodID" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Period">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="period in data.periods"><span ng-bind-html="period.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label for="">Limit Amount</label> <input type="number" step="0.01" class="form-control" placeholder="" ng-model="data.details[0].LimitAmount" required=""></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-3 control-label">Request Mileage</label><div class="col-xs-8 col-sm-9"><input type="checkbox" ng-model="data.details[0].MileageRequired"></div></div><div class="form-group"><label for="">Pin</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Pin" maxlength="4" size="4" required=""></div><div class="form-group"><label for="">iButton</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].iButtonID"></div></div><div class="col-md-6"><div class="form-group"><label for="">Issued Date</label><date-component value="data.details[0].Issued"></date-component></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Holidays</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].PublicHolidays"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Monday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Monday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Tuesday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Tuesday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Wednesday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Wednesday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Thursday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Thursday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Friday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Friday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Saturday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Saturday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Sunday</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].Sunday"></div></div><div class="form-group" style="margin: 0 -15px 0 -15px !important"><label for="" class="col-sm-2 control-label">From Time</label><div class="col-sm-4"><time-component value="data.details[0].FromTime" style="margin-top: 0px;"></time-component></div><label for="" class="col-sm-2 control-label">To Time</label><div class="col-sm-4"><time-component value="data.details[0].ToTime" style="margin-top: 0px;"></time-component></div></div><div class="form-group" style="clear:both;margin: 0 -15px 0 -15px !important; min-height: 40px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Has Expired</label><div class="col-xs-8 col-sm-10"><input type="checkbox" ng-model="data.details[0].hasExpired"></div></div><div class="form-group" ng-if="data.details[0].hasExpired" style="margin: 0 -15px 0 -15px !important;"><label for="" class="col-xs-4 col-sm-2 control-label">Expiry Date</label><div class="col-xs-8 col-sm-10"><date-component value="data.details[0].Expired"></date-component></div></div></div></div>');
$templateCache.put('app/pages/companies/account-create/template.html','<company-loader-component class="printRemove"></company-loader-component><form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/account-create/detailsFormFields.html\'"></div><div style="text-align: center;" class="printRemove"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Account</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/create/template.html','<form name="forms.details" class="printSection"><div class="row"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/details/detailsFormFields.html\'"></div><div style="text-align: center;" class="printRemove"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Company</button></div></div></div></form>');
$templateCache.put('app/pages/companies/accounts-list/postpayList.html','<div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover" st-table="postpay" st-safe-src="data.postpay"><thead><tr class="sortable"><th>Actions</th><th st-sort="IButton">iButton</th><th st-sort="AccountCode">Acc. Code</th><th st-sort="ClientName">Client Name</th><th st-sort="Balance" style="text-align: right;">Balance</th><th st-sort="Limit" style="text-align: right;">Limit</th><th st-sort="LimitPeriod">Limit Period</th></tr><tr><th><button type="submit" class="status-button btn btn-xs btn-primary" ui-sref="companiesAccountCreate({ companyId: data.companyId })">New</button></th><th><input st-search="IButton" placeholder="Search iButton" class="input-sm form-control search-input" type="search"></th><th><input st-search="AccountCode" placeholder="Search Acc. Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="ClientName" placeholder="Search Client Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in postpay"><td><a ng-click="fnPostpayDetails( item );"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-person"></i></a></td><td>{{ item[\'IButton\'] }}</td><td>{{ item[\'AccountCode\'] }}</td><td>{{ item[\'ClientName\'] }}</td><td style="text-align: right;">&euro;{{ item[\'Balance\'] | number:2 }}</td><td style="text-align: right;">&euro;{{ item[\'Limit\'] | number:2 }}</td><td>{{ item[\'LimitPeriod\'] }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/companies/accounts-list/prepayList.html','<div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover" st-table="prepay" st-safe-src="data.prepay"><thead><tr class="sortable"><th>Actions</th><th st-sort="IButton">iButton</th><th st-sort="AccountCode">Acc. Code</th><th st-sort="ClientName">Client Name</th><th st-sort="InAccount" style="text-align: right;">In Account</th></tr><tr><th><button type="submit" class="status-button btn btn-xs btn-primary" ui-sref="companiesAccountCreate({ companyId: data.companyId })">New</button></th><th><input st-search="IButton" placeholder="Search iButton" class="input-sm form-control search-input" type="search"></th><th><input st-search="AccountCode" placeholder="Search Acc. Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="ClientName" placeholder="Search Client Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in prepay"><td><a ng-click="fnPrepayDetails( item );"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-person"></i></a></td><td>{{ item[\'IButton\'] }}</td><td>{{ item[\'AccountCode\'] }}</td><td>{{ item[\'ClientName\'] }}</td><td style="text-align: right;">&euro;{{ item[\'InAccount\'] | number:2 }}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/companies/accounts-list/template.html','<company-loader-component></company-loader-component><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-title="Accounts" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/accounts-list/postpayList.html\'"></div></div></div></div>');
$templateCache.put('app/pages/companies/details/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].CompanyCode" required=""></div><div class="form-group"><label for="">Credit Limit</label> <input type="number" class="form-control" placeholder="" ng-model="data.details[0].CreditLimit"> <span class="help-block sub-little-text">Balance <b>{{ data.details[0].Balance }}</b></span></div><div class="form-group"><label for="">Company Name</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Name" required=""></div><div class="form-group"><label for="">Attention</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Attention"></div><div class="form-group"><label for="">Address Line 1</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Address1"></div><div class="form-group"><label for="">Address Line 2</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Address2"></div><div class="form-group"><label for="">City</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].City"></div><div class="form-group"><label for="">Post Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].PostCode"></div><div class="form-group"><label for="">Country</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Country"></div></div><div class="col-md-6"><div class="form-group"><label for="">Vat Number</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].VatNumber"></div><div class="form-group"><label for="">Telephone</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Tel"></div><div class="form-group"><label for="">Fax</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Fax"></div><div class="form-group"><label for="">Mobile</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Mob"></div><div class="form-group"><label for="">Email</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Email"></div><div class="form-group"><label for="">Other</label> <textarea class="form-control" placeholder="" ng-model="data.details[0].Other"></textarea></div><div class="form-group"><label for="">Request Mileage</label> <input type="checkbox" ng-model="data.details[0].Mileage" style="margin:5px 0 0 10px;"></div><div class="form-group"><label for="">Request Document No.</label> <input type="checkbox" ng-model="data.details[0].DocumentNr" style="margin:5px 0 0 10px;"></div></div>');
$templateCache.put('app/pages/companies/details/template.html','<company-loader-component class="printRemove"></company-loader-component><form name="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/details/detailsFormFields.html\'"></div><div style="text-align: center;" class="printRemove"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Company Details</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/ibutton-search/template.html','<form name="forms.details"><div class="row"><div class="col-xlg-4 col-md-4 col-sm-6"><div ba-panel="" ba-panel-class="with-scroll"><div class="form-group"><label for="">iButton</label> <input type="text" class="form-control" placeholder="" ng-model="data.ibutton" required=""></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="search()">Search</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/list/template.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll" print-section=""><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover" st-table="companies" st-safe-src="data.companies"><thead><tr class="sortable"><th class="printRemove">Actions</th><th st-sort="Code">Code</th><th st-sort="CompanyName">Company Name</th><th st-sort="ContactPerson">Contact Person</th><th st-sort="Credit" style="text-align: right;">Credit</th><th st-sort="Balance" style="text-align: right;">Balance</th></tr><tr class="printRemove"><th></th><th><input st-search="Code" placeholder="Search Code" class="input-sm form-control search-input" type="search"></th><th><input st-search="CompanyName" placeholder="Search Company Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="ContactPerson" placeholder="Search Contact Person" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in companies"><td class="printRemove" style="white-space:nowrap;"><a ng-click="fnDetails( item );"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-information"></i></a> <a ng-click="fnAccounts( item );"><i style="font-size:14px; padding: 0 5px 0 5px;" class="btn-info ion-ios-people"></i></a> <a ng-click="fnPostings( item );"><i style="font-size:14px; padding: 0 5px 0 5px;" class="btn-success ion-ios-cart"></i></a></td><td>{{ item[\'Code\'] }}</td><td>{{ item[\'CompanyName\'] }}</td><td>{{ item[\'ContactPerson\'] }}</td><td style="text-align: right;">&euro;{{ item[\'Credit\'] | number:2 }}</td><td style="text-align: right;">&euro;{{ item[\'Balance\'] | number:2 }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/companies/posting-details/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Post Date</label><date-component value="data.details[0].PostingDate"></date-component></div><div class="form-group"><label for="">Ref Chit No</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].ChitNumber"></div><div class="form-group"><label for="">Description</label> <textarea class="form-control" placeholder="" ng-model="data.details[0].Description"></textarea></div><div class="form-group" ng-if="data.details[0].PostingTypeid == 1"><label for="">Department</label><ui-select ng-model="data.details[0].DepartmentId" class="btn-group bootstrap-select form-control" ng-disabled="false" ng-change="fnDeptChanged()" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Department">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="dept in data.departments"><span ng-bind-html="dept.name"></span></ui-select-choices></ui-select></div><div class="form-group row"><div class="col-md-4"><label>Posting</label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="debit" ng-model="data.details[0].creditOrDebit"> <span>Debit</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="credit" ng-model="data.details[0].creditOrDebit"> <span>Credit</span></label></div></div><div class="form-group"><label for="">Amount</label> <input type="number" step="0.01" class="form-control" placeholder="" ng-model="data.details[0].amount" required=""></div></div><div class="col-md-6"></div>');
$templateCache.put('app/pages/companies/posting-details/template.html','<company-loader-component></company-loader-component><form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/posting-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Posting Details</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/posting-post-pay-create/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Post Date</label><date-component value="data.details[0].PostingDate"></date-component></div><div class="form-group"><label for="">Ref Chit No</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].ChitNumber"></div><div class="form-group"><label for="">Description</label> <textarea class="form-control" placeholder="" ng-model="data.details[0].Description"></textarea></div><div class="form-group"><label for="">Department</label><ui-select ng-model="data.details[0].DepartmentId" class="btn-group bootstrap-select form-control" ng-disabled="false" ng-change="fnDeptChanged()" append-to-body="true" search-enabled="true" required=""><ui-select-match placeholder="Select Department">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="dept in data.departments | filter: $select.search"><span ng-bind-html="dept.name"></span></ui-select-choices></ui-select></div><div class="form-group row"><div class="col-md-4"><label>Posting</label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="debit" ng-model="data.details[0].creditOrDebit"> <span>Debit</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="credit" ng-model="data.details[0].creditOrDebit"> <span>Credit</span></label></div></div><div class="form-group"><label for="">Amount</label> <input type="number" step="0.01" class="form-control" placeholder="" ng-model="data.details[0].amount" required=""></div></div><div class="col-md-6"></div>');
$templateCache.put('app/pages/companies/posting-post-pay-create/template.html','<company-loader-component></company-loader-component><form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/posting-post-pay-create/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Posting</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/posting-pre-pay-create/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Post Date</label><date-component value="data.details[0].PostingDate"></date-component></div><div class="form-group"><label for="">Ref Chit No</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].ChitNumber"></div><div class="form-group"><label for="">Description</label> <textarea class="form-control" placeholder="" ng-model="data.details[0].Description"></textarea></div><div class="form-group row"><div class="col-md-4"><label>Posting</label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="debit" ng-model="data.details[0].creditOrDebit"> <span>Debit</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="credit" ng-model="data.details[0].creditOrDebit"> <span>Credit</span></label></div></div></div><div class="col-md-6"><table class="table table-striped table-hover" st-safe-src="data.details[0].accounts"><thead><tr class="sortable"><th>Client Name</th><th style="text-align: right;">In Account</th><th>Amount(s)</th></tr></thead><tbody><tr ng-repeat="item in data.details[0].accounts"><td>{{ item[\'name\'] }}</td><td style="text-align: right;">&euro;{{ item[\'PrePaidInAc\'] | number:2 }}</td><td><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item.amount"></td></tr></tbody></table></div>');
$templateCache.put('app/pages/companies/posting-pre-pay-create/template.html','<company-loader-component></company-loader-component><form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/companies/posting-pre-pay-create/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Posting</button></div></div></div></div></form>');
$templateCache.put('app/pages/companies/postings-list/template.html','<company-loader-component></company-loader-component><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll autoDataTable"><button type="submit" class="btn btn-xs btn-info" ui-sref="companyPostPayPostingCreate({ companyId: data.companyId })">New Posting</button><table class="table table-striped table-hover" st-table="postings" st-safe-src="data.postings"><thead><tr class="sortable"><th>Actions</th><th st-sort="Date">Date</th><th st-sort="Dept">Dept</th><th st-sort="ChitNo">Chit No</th><th st-sort="Description">Description</th><th st-sort="Debit" style="text-align: right;">Debit</th><th st-sort="Credit" style="text-align: right;">Credit</th></tr><tr><th></th><th></th><th><input st-search="Dept" placeholder="Search Dept" class="input-sm form-control search-input" type="search"></th><th><input st-search="ChitNo" placeholder="Search Chit No" class="input-sm form-control search-input" type="search"></th><th><input st-search="Description" placeholder="Search Client Name" class="input-sm form-control search-input" type="search"></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="item in postings"><td><a ng-click="fnPostingDetails( item );"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-edit"></i></a> <a ng-click="fnPostingPrint( item );"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-default ion-android-print"></i></a></td><td>{{ fnFormatDate( item[\'Date\'] ) }}</td><td ng-if="item[\'departmentid\'] != 0">{{ item[\'Dept\'] }}</td><td ng-if="item[\'departmentid\'] == 0">iButton Fuel Sale</td><td>{{ item[\'ChitNo\'] }}</td><td>{{ item[\'Description\'] }}</td><td style="text-align: right;">&euro;{{ item[\'Debit\'] | number:2 }}</td><td style="text-align: right;">&euro;{{ item[\'Credit\'] | number:2 }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/companies/reports/template.html','<uib-accordion><uib-accordion-group heading="Debtors" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>Date:</em></label><date-component value="reports.debtors.date"></date-component></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnDebtors(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnDebtors(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Debtor List" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>From:</em></label><date-component value="reports.debtorList.from"></date-component></div><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>To:</em></label><date-component value="reports.debtorList.to"></date-component></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnDebtorList(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnDebtorList(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Company Accounts" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>From:</em></label><date-component value="reports.postpayAccounts.from"></date-component></div><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>To:</em></label><date-component value="reports.postpayAccounts.to"></date-component></div></div><div class="row"><div class="col-xlg-6 col-md-12 col-sm-12"><label><em>Company</em></label><div class="form-group"><ui-select ng-model="reports.postpayAccounts.company" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="company in companies.records | filter: $select.search"><span ng-bind-html="company.name"></span></ui-select-choices></ui-select></div></div><div class="col-xlg-6 col-md-12 col-sm-12"><label><em>Email Filter</em></label><div class="form-group"><ui-select ng-model="reports.postpayAccounts.emailFilter" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Select Option">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="emailFilter in emailFilters.records | filter: $select.search"><span ng-bind-html="emailFilter.name"></span></ui-select-choices></ui-select></div></div></div><div class="row" ng-if="!reports.postpayAccounts.anyBalance"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>Balance Less Then:</em></label> <input type="number" class="form-control" ng-model="reports.postpayAccounts.balanceLessThen"></div></div><div class="row" style="height: 30px !important; margin-top: 20px;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.postpayAccounts.anyBalance"> <span>Any Balance</span></label></div></div><div class="row" style="height: 30px !important;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.postpayAccounts.anyTransaction"> <span>Show only if any transaction was performed.</span></label></div></div><div class="row" style="height: 30px !important;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.postpayAccounts.summary"> <span>Summary</span></label></div></div><div class="row" style="height: 30px !important;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.postpayAccounts.deptartmentAnalysis"> <span>Department Analysis</span></label></div></div><div class="row" style="height: 30px !important;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.postpayAccounts.statistics"> <span>Statistics</span></label></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnPostpayAccounts(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnPostpayAccounts(\'pdf\')">PDF</button> <button ng-if="reports.postpayAccounts.company.id != 0" type="button" class="btn btn-warning btn-sm" ng-click="fnPostpayAccounts(\'email\')">Send Email</button> <button ng-if="reports.postpayAccounts.emailFilter.id == 1" type="button" class="btn btn-danger btn-sm" ng-click="fnPostpayAccounts(\'emailList\')">Use Email List</button></div></div><hr ng-show="reports.postpayAccounts.emailList"><div class="row" ng-show="reports.postpayAccounts.emailList"><div class="col-xlg-6 col-md-12 col-sm-12"><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover" st-table="emailListData" st-safe-src="reports.postpayAccounts.emailListData"><thead><tr class="sortable"><th st-sort="CompanyName">Company Name</th><th st-sort="Balance" style="text-align: right;">Balance</th><th class="printRemove">Actions</th></tr></thead><tbody><tr ng-repeat="item in emailListData"><td style="padding: 5px 8px;">{{ item[\'Name\'] }}</td><td style="padding: 5px 8px;text-align: right;">&euro;{{ item[\'Balance\'] | number:2 }}</td><td class="printRemove" style="white-space:nowrap;"><button ng-show="item[\'status\'] == -1" type="button" class="btn btn-danger btn-with-ico btn-xs" ng-click="fnPostpayAccounts(\'emailListItem\', item)"><i style="color:#900;" class="ion-email">Sending Error</i></button> <button ng-show="item[\'status\'] == 0" type="button" class="btn btn-warning btn-with-ico btn-xs" ng-click="fnPostpayAccounts(\'emailListItem\', item)"><i style="color:#000;" class="ion-email">Send</i></button> <i ng-show="item[\'status\'] == 1" style="color:#099;" class="ion-email">Sending</i> <i ng-show="item[\'status\'] == 2" style="color:#090;" class="ion-email">Sent</i></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group heading="Accounts" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-12 col-sm-12"><label><em>Company</em></label><div class="form-group"><ui-select ng-model="reports.accounts.company" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="company in companies.records | filter: $select.search"><span ng-bind-html="company.name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnAccounts(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnAccounts(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Transactions" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>From:</em></label><date-component value="reports.transactions.from"></date-component></div><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>To:</em></label><date-component value="reports.transactions.to"></date-component></div></div><div class="row"><div class="col-xlg-6 col-md-12 col-sm-12"><label><em>Company</em></label><div class="form-group"><ui-select ng-model="reports.transactions.company" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="company in companies.records | filter: $select.search"><span ng-bind-html="company.name"></span></ui-select-choices></ui-select></div></div></div><div class="row" style="height: 30px !important;"><div class="col-xlg-12 col-md-12 col-sm-12"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="reports.transactions.incTotalOfZero"> <span>Include Total of Zero</span></label></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnTransactions(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnTransactions(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Departments" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>From:</em></label><date-component value="reports.departments.from"></date-component></div><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>To:</em></label><date-component value="reports.departments.to"></date-component></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnDepartments(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnDepartments(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Company Postings" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>From:</em></label><date-component value="reports.companyPostings.from"></date-component></div><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>To:</em></label><date-component value="reports.companyPostings.to"></date-component></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnCompanyPostings(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnCompanyPostings(\'pdf\')">PDF</button></div></div></uib-accordion-group><uib-accordion-group heading="Last Payment" panel-class="bootstrap-panel accordion-panel panel-default"><div class="row"><div class="col-xlg-6 col-md-6 col-sm-6"><label><em>more than days ago</em></label><p class="input-group"><input type="number" class="form-control" ng-model="reports.lastPayment.days"></p></div></div><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><button type="button" class="btn btn-primary btn-sm" ng-click="fnLastPayment(\'html\')">HTML</button> <button type="button" class="btn btn-secondary btn-sm" ng-click="fnLastPayment(\'pdf\')">PDF</button></div></div></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/login/change-password/template.html','<form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="form-group"><label for="">Type your current password</label> <input type="password" class="form-control" placeholder="" ng-model="changePassword.old" required=""></div><div class="form-group"><label for="">Your new password</label> <input type="password" class="form-control" placeholder="" ng-model="changePassword.new1" required=""></div><div class="form-group"><label for="">Re-type you new password for confirmation</label> <input type="password" class="form-control" placeholder="" ng-model="changePassword.new2" required=""></div></div><div class="col-md-6"></div></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="changePassword()">Change Password</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/departments/template.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll" print-section=""><button type="submit" class="btn btn-xs btn-info printRemove" ui-sref="station.departmentCreate">Create Department</button><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover"><thead><tr><th class="printRemove">Actions</th><th>Code</th><th>Department</th><th>Default</th></tr></thead><tbody><tr ng-repeat="item in data.list"><td class="printRemove"><a ui-sref="station.departmentDetails({ departmentId: item.departmentid })"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-information"></i></a></td><td>{{ item[\'Code\'] }}</td><td>{{ item[\'Name\'] }}</td><td>{{ item[\'default\'] }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/station/departments-create/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/departments-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary printRemove" ng-click="createRecord()">Create Department</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/departments-details/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Code" required=""></div><div class="form-group"><label for="">Department</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Name" required=""></div><div class="form-group"><label for="">Credit/Debit</label><ui-select ng-model="data.details[0].default" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Default">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="default in data.defaults"><span ng-bind-html="default.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-6"></div>');
$templateCache.put('app/pages/station/departments-details/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/departments-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary printRemove" ng-click="updateRecord()">Update Department</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/details/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><div class="form-group" ng-repeat="item in data.details"><label for="">{{ item[\'desc\'] }}</label> <input type="text" class="form-control" placeholder="" ng-model="item.value"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary printRemove" ng-click="updateRecord()">Update Details</button></div></div><div class="col-md-6"></div></div></div></div></div></form>');
$templateCache.put('app/pages/station/fuel-purchases/template.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll" print-section=""><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-xs btn-info printRemove" ui-sref="station.fuelpurchaseCreate">Create Fuel Purchase</button></div><div class="col-md-6"><div class="form-group select-page-size-wrap" style="float:right;"><select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="pageSize" ng-options="i for i in [5,10,15,20,25]"></select></div></div></div><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover" st-table="list" st-safe-src="data.list"><thead><tr><th class="printRemove">Actions</th><th>Date</th><th>Time</th><th>Supplier</th><th>Invoice</th></tr><tr class="printRemove"><th></th><th><input st-search="Date" placeholder="Search Date" class="input-sm form-control search-input" type="search"></th><th></th><th><input st-search="Supplier" placeholder="Search Supplier" class="input-sm form-control search-input" type="search"></th><th><input st-search="Invoice" placeholder="Search Invoice" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in list"><td class="printRemove" style="white-space: nowrap;"><button type="button" class="btn btn-primary btn-xs" ng-click="fnGetFuelReport( item.FuelPurchaseId,\'html\' )">HTML</button> <button type="button" class="btn btn-secondary btn-xs" ng-click="fnGetFuelReport( item.FuelPurchaseId, \'pdf\' )">PDF</button></td><td>{{ item[\'Date\'] }}</td><td>{{ item[\'Time\'] }}</td><td>{{ item[\'Supplier\'] }}</td><td>{{ item[\'Invoice\'] }}</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="pageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/station/fuel-purchases-create/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-4"><div class="form-group"><label for="">Supplier</label><ui-select ng-model="data.details[0].SupplierId" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Search Supplier">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="supplier in data.suppliers | filter: $select.search"><span ng-bind-html="supplier.name"></span></ui-select-choices></ui-select></div></div></div><div class="row" style="margin-bottom: 20px;"><div class="col-md-12"><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover"><thead><tr><th>Tank</th><th>Stock</th><th>Free</th><th>Fuel</th><th>Litres</th><th>Cost</th><th>VAT Cost</th><th>Selling</th><th>VAT Selling</th></tr></thead><tbody><tr ng-repeat="item in data.details[0].tanks"><td>{{ item[\'Tank\'] }}</td><td>{{ item[\'Stock\'] }}</td><td>{{ item[\'Freespace\'] }}</td><td>{{ item[\'Fuel\'] }}</td><td style="min-width:100px;"><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'Litres\']" required=""></td><td style="min-width:100px;"><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'Cost\']" required=""></td><td style="min-width:100px;"><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'VATCost\']" required=""></td><td style="min-width:100px;"><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'Selling\']" required=""></td><td style="min-width:100px;"><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'VATSelling\']" required=""></td></tr></tbody></table></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="">Document</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Document" required=""></div></div><div class="col-md-4"><div class="form-group"><label for="">Operator</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Operator" required=""></div></div><div class="col-md-4"><div class="form-group"><label for="" style="display:block !important;">Delivered</label><div class="row"><div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><date-component value="data.details[0].DeliveryDateTime"></date-component></div><div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="margin-top: -22px;"><time-component value="data.details[0].DeliveryDateTime"></time-component></div></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="">Seals</label> <input type="number" class="form-control" placeholder="" ng-model="data.details[0].Seals" required=""></div></div><div class="col-md-4"><div class="form-group"><label for="">Truck</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Truck" required=""></div></div><div class="col-md-4"><div class="form-group"><label for="">Departed</label><div class="row"><div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"><date-component value="data.details[0].DepartedDateTime"></date-component></div><div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="margin-top: -22px;"><time-component value="data.details[0].DepartedDateTime"></time-component></div></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label for="">Cheque</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Cheque" required=""></div></div><div class="col-md-4"><div class="form-group"><label for="">Amount</label> <input type="number" step="0.01" class="form-control" placeholder="" ng-model="data.details[0].Amount" required=""></div></div></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Fuel Purchase</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/fuel-rates/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table table-striped table-hover"><thead><tr class="sortable"><th>Fuel</th><th>Rate</th></tr></thead><tbody><tr ng-repeat="item in data.records"><td>{{ item[\'Name\'] }}</td><td><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'PPU\']"></td></tr></tbody></table></div><div class="col-md-6"></div></div><div style="text-align: center; margin-top:20px;"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Rates</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/pumps-calibrate/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table"><tbody ng-repeat="(pumpid, records) in data.records | groupBy: \'pumpid\'"><tr><th colspan="4"><h4 style="padding-top: 10px;"><center>Pump {{ pumpid }}</center></h4></th></tr><tr ng-repeat="item in records" style="color:#{{ item[\'FuelColor\'] }};"><td>Nozzle {{ item[\'nozzleid\'] }}</td><td>{{ item[\'FuelCode\'] }}</td><td>Tank {{ item[\'tankid\'] }}</td><td><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item[\'NozzleReading\']"></td></tr></tbody></table></div><div class="col-md-6"></div></div><div style="text-align: center; margin-top:20px;"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Nozzle Readings</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/pumps/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-xs btn-info printRemove" ui-sref="station.pumpsCalibrate">Calibrate Pump Readings</button><table class="table"><tbody ng-repeat="(pumpid, records) in data.records | groupBy: \'pumpid\'"><tr><th colspan="4"><h4 style="padding-top: 10px;"><center>Pump {{ pumpid }}</center></h4></th></tr><tr ng-repeat="item in records" style="color:#{{ item[\'FuelColor\'] }};"><td>Nozzle {{ item[\'nozzleid\'] }}</td><td>{{ item[\'FuelCode\'] }}</td><td>Tank {{ item[\'tankid\'] }}</td><td>{{ item[\'NozzleReading\'] }}</td></tr></tbody></table></div><div class="col-md-6"></div></div></div></div></div></form>');
$templateCache.put('app/pages/station/receipts-footers/template.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll" print-section=""><button type="submit" class="btn btn-xs btn-info" ui-sref="station.receiptsFootersCreate">Create Receipt Footer</button><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover"><thead><tr><th>Actions</th><th>Line</th><th>From Date</th><th>To Date</th></tr></thead><tbody><tr ng-repeat="item in data.list"><td><a ui-sref="station.receiptsFootersDetail({ footerId: item.id })"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-information"></i></a></td><td ng-bind-html="item[\'Lines\']"></td><td>{{ item[\'FromDate\'] }}</td><td>{{ item[\'ToDate\'] }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/station/receipts-footers-create/template.html','<form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/receipts-footers-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="createRecord()">Create Footer</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/receipts-footers-details/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Line 1</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Line1" required=""></div><div class="form-group"><label for="">Line 2</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Line2"></div><div class="form-group"><label for="">Line 3</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Line3"></div><div class="form-group"><label for="">From Date</label><date-component value="data.details[0].FromDate"></date-component></div><div class="form-group"><label for="">To Date</label><date-component value="data.details[0].ToDate"></date-component></div></div><div class="col-md-6"></div>');
$templateCache.put('app/pages/station/receipts-footers-details/template.html','<form name="forms.details" id="forms.details"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/receipts-footers-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Footer</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/suppliers-create/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/suppliers-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary printRemove" ng-click="createRecord()">Create Supplier</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/suppliers-details/detailsFormFields.html','<div class="col-md-6"><div class="form-group"><label for="">Company Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].CompanyCode" required=""></div><div class="form-group"><label for="">Company Name</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Name" required=""></div><div class="form-group"><label for="">Attention</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Attention"></div><div class="form-group"><label for="">Address Line 1</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Address1"></div><div class="form-group"><label for="">Address Line 2</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Address2"></div><div class="form-group"><label for="">City</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].City"></div><div class="form-group"><label for="">Post Code</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].PostCode"></div><div class="form-group"><label for="">Country</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Country"></div></div><div class="col-md-6"><div class="form-group"><label for="">Vat Number</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].VatNumber"></div><div class="form-group"><label for="">Telephone</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Tel"></div><div class="form-group"><label for="">Fax</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Fax"></div><div class="form-group"><label for="">Mobile</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Mob"></div><div class="form-group"><label for="">Email</label> <input type="text" class="form-control" placeholder="" ng-model="data.details[0].Email"></div><div class="form-group"><label for="">Other</label> <textarea class="form-control" placeholder="" ng-model="data.details[0].Other"></textarea></div></div>');
$templateCache.put('app/pages/station/suppliers-details/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div ng-include="\'app/pages/station/suppliers-details/detailsFormFields.html\'" class="row"></div><div style="text-align: center;"><button type="submit" class="btn btn-primary printRemove" ng-click="updateRecord()">Update Supplier</button></div></div></div></div></form>');
$templateCache.put('app/pages/station/suppliers/template.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll" print-section=""><button type="submit" class="btn btn-xs btn-info printRemove" ui-sref="station.supplierCreate">Create Supplier</button><div class="horizontal-scroll autoDataTable"><table class="table table-striped table-hover"><thead><tr><th class="printRemove">Actions</th><th>Company Name</th><th>Contact Person</th><th>Telephone</th></tr></thead><tbody><tr ng-repeat="item in data.list"><td class="printRemove"><a ui-sref="station.supplierDetails({ supplierId: item.supplierid })"><i style="font-size:14px; padding: 0 8px 0 8px;" class="btn-primary ion-information"></i></a></td><td>{{ item[\'name\'] }}</td><td>{{ item[\'attention\'] }}</td><td>{{ item[\'tel\'] }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/station/tanks/template.html','<div class="row"><div ba-panel="" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 20px;"><div class="col-md-12"><button type="submit" class="btn btn-xs btn-info" ui-sref="station.tankscalibrate">Calibrate Tanks Readings</button></div></div><div class="row printSection" ng-if="data.records.length > 0"><div class="col-md-12"><svg width="220" height="170" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" ng-repeat="tank in data.records track by $index"><g><title>Layer 1</title><rect stroke="#000000" height="150" width="80" y="0" x="0" fill="#cccccc"></rect><rect height="{{ getHeight( tank ) }}" width="80" y="{{ getY( tank ) }}" x="0" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke="#000000" fill="#{{ tank.fuelcolor }}"></rect><rect height="20" width="80" y="130" x="0" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke="#000000" fill="#000000"></rect><text stroke="#000000" xml:space="preserve" text-anchor="middle" font-family="verdana" font-size="16" y="146" x="40" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#ffff56">Tank {{ tank.tankid }}</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="10" y="8" x="85" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#0000ff">Fuel Type</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="20" y="30" x="90" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#{{ tank.fuelcolor }}">{{ tank.fuelname }}</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="10" y="46" x="85" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#0000ff">Free Space</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="16" y="65" x="90" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">{{ round(tank.free) }} Lt</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="10" y="86" x="85" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#0000ff">Volume</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="16" y="105" x="90" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">{{ round(tank.litresintank) }} Lt</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="10" y="126" x="85" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#0000ff">Tank Capacity</text><text stroke="#000000" xml:space="preserve" text-anchor="left" font-family="verdana" font-size="16" y="145" x="90" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">{{ round(tank.capacity) }} Lt</text></g></svg></div></div></div></div>');
$templateCache.put('app/pages/station/tanks-calibrate/template.html','<form name="forms.details" id="forms.details" class="printSection"><div class="row"><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-6"><table class="table table-striped table-hover"><thead><tr class="sortable"><th>Tank</th><th>Fuel</th><th>Litres</th></tr></thead><tbody><tr ng-repeat="item in data.records"><td>Tank {{ item[\'tankid\'] }}</td><td>{{ item[\'fuelname\'] }}</td><td><input type="number" step="0.01" class="form-control" placeholder="" ng-model="item.litresintank"></td></tr></tbody></table></div><div class="col-md-6"></div></div><div style="text-align: center; margin-top:20px;"><button type="submit" class="btn btn-primary" ng-click="updateRecord()">Update Tank Readings</button></div></div></div></div></form>');
$templateCache.put('app/pages/sales/button/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'Dispensed\']" decimals="{Litres:2,Rate:3}" totals="[\'Dispensed\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/card/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" decimals="{Litres:2,Rate:3}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/card-batches/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" totals="[\'CashIn\',\'Dispensed\',\'Refunded\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/cash-inserted/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'Note\']" decimals="{}" totals="[\'Note\',]" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/cash/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="\'by OPT\'" data="data.byOpt" server="optCallServer" currencies="[\'Total\']" totals="[\'Total\']" paging-enabled="false" print-section=""></auto-data-table-component><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Details" ba-panel-class="with-scroll" print-section=""><div class="horizontal-scroll autoDataTable"><table class="table table-striped"><thead><tr><th>Receipt id</th><th>Date</th><th>Time</th><th>Day Receipt Id</th><th>VRN</th><th>Pump</th><th>Noz.</th><th>Fuel</th><th style="text-align: right;">CashIn</th><th style="text-align: right;">Dispensed</th><th style="text-align: right;">Refunded</th><th style="text-align: right;">Litres</th><th style="text-align: right;">Rate</th><th>OPT Desc</th></tr></thead><tbody><tr ng-repeat="item in data.details"><td>{{ item[\'Receipt id\'] }}</td><td>{{ item[\'Date\'] }}</td><td>{{ item[\'Time\'] }}</td><td>{{ item[\'Day Receipt Id\'] }}</td><td>{{ item[\'VRN\'] }}</td><td>{{ item[\'Pump\'] }}</td><td>{{ item[\'Noz.\'] }}</td><td>{{ item[\'Fuel\'] }}</td><td style="text-align: right;">&euro;{{ item[\'CashIn\'] | number:2 }}</td><td style="text-align: right;">&euro;{{ item[\'Dispensed\'] | number:2 }}</td><td ng-if="item[\'CashIn\'] > item[\'Dispensed\'] && item[\'Refunded\'] == 0" style="text-align: right;"><a ui-sref="sales.newrefundvrn({date: getItemDate( item ), dayReceiptId: item[\'Day Receipt Id\'], vrn: item[\'VRN\'] })">&euro;{{ item[\'Refunded\'] | number:2 }}</a></td><td ng-if="item[\'CashIn\'] <= item[\'Dispensed\'] || item[\'Refunded\'] != 0" style="text-align: right;">&euro;{{ item[\'Refunded\'] | number:2 }}</td><td style="text-align: right;">{{ item[\'Litres\'] | number:2 }}</td><td style="text-align: right;">{{ item[\'Rate\'] | number:3 }}</td><td>{{ item[\'OPT Desc\'] }}</td></tr><tr><td colspan="8"></td><td class="totals" style="text-align:right;">&euro;{{ data.details.totals[\'CashIn\'] | number:2 }}</td><td class="totals" style="text-align:right;">&euro;{{ data.details.totals[\'Dispensed\'] | number:2 }}</td><td class="totals" style="text-align:right;">&euro;{{ data.details.totals[\'Refunded\'] | number:2 }}</td><td class="totals" style="text-align:right;">{{ data.details.totals[\'Litres\'] | number:2 }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/sales/fuel-monthly/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" headers-break-line="true" currencies="fields.currencies" decimals="fields.decimals" totals="fields.totals" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/fuel-daily/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" headers-break-line="true" currencies="fields.currencies" decimals="fields.decimals" totals="fields.totals" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/kiosk/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" decimals="{Litres:2,Rate:3}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/fuel-yearly/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><div style="margin-bottom:20px;"><button type="submit" class="btn btn-xs btn-info" print-remove="" ng-click="fnToggleRowWithColumn()">Toggle</button></div><auto-data-table-component heading="title" data="data.records" headers-break-line="true" currencies="fields.currencies" decimals="fields.decimals" totals="fields.totals" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/manual/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'Dispensed\']" decimals="{Litres:2,Rate:3}" totals="[\'Dispensed\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/pump/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" styles="{\'Pump No\':\'left\',\'Nozzle No\':\'left\'}" decimals="{Litres:2,Rate:3}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/refund-new/template.html','<form class="row form-inline"><div class="form-group col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2"><label>Date</label><date-component value="date"></date-component></div><div class="form-group col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2" style="padding-bottom:15px"><label>Day Receipt Id</label> <input type="number" class="form-control" ng-model="dayReceiptId"></div><div class="form-group col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2" style="padding-bottom:15px"><label>VRN</label> <input type="number" class="form-control" ng-model="vrn"></div><button type="submit" class="btn btn-primary" ng-click="fnSubmit()" style="margin-top: 20px;">Submit</button></form><auto-data-table-component heading="title" data="data.records" styles="{ \'Receipt id\':\'left\', \'Day Receipt Id\':\'left\', \'Pump\':\'left\', \'vrn\':\'left\', \'Noz.\':\'left\' }" headers-break-line="true" currencies="[ \'CashIn\', \'Dispensed\', \'Refunded\' ]" decimals="{\'Litres\':2, Rate:3}"></auto-data-table-component><div class="row" ng-if="(data.records[0][\'Refunded\'] == 0) && (data.records[0][\'CashIn\'] - data.records[0][\'Dispensed\'] > 0 )"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><form class="row form-inline"><div class="form-group col-xs-6 col-sm-4 col-md-3 col-lg-2 col-xl-2"><label>New Refund Value</label> <input type="number" class="form-control" ng-model="newRefundAmount" step="0.01"></div><button type="submit" class="btn btn-primary" ng-click="fnSubmitNewRefund()" style="margin-top: 20px;">Update</button></form></div></div></div><div class="row" ng-if="(data.records[0][\'Refunded\'] != 0) && (data.records[0][\'CashIn\'] - data.records[0][\'Dispensed\'] > 0 )"><div class="col-xs-12"><div ba-panel="" ba-panel-class="with-scroll"><form class="row form-inline"><div>This receipt has been refunded.<br>If this receipt has been marked as refunded by mistake please <button type="submit" class="btn btn-primary" ng-click="fnSubmitCancelRefund()" style="margin-right:10px;">Click Here</button> to cancel the refund.</div></form></div></div></div><auto-data-table-component ng-if="data.recordsAudit.length > 0" heading="titleAudit" data="data.recordsAudit" currencies="[ \'Amount\' ]"></auto-data-table-component>');
$templateCache.put('app/pages/sales/refunds-audit/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'Amount\']" styles="{\'Receipt ID\':\'left\'}" totals="[\'Amount\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/refunds/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><div class="row" print-section=""><div class="col-xlg-12 col-md-12 col-sm-12"><div ba-panel="" ba-panel-class="with-scroll"><div class="horizontal-scroll autoDataTable"><button type="submit" class="btn btn-xs btn-info" print-remove="" ng-click="fnRefundLastDays(14)">Last 2 Weeks</button> <button type="submit" class="btn btn-xs btn-info" print-remove="" ng-click="fnRefundLastDays(7)">Last Week</button> <button type="submit" class="btn btn-xs btn-info" print-remove="" ng-click="fnRefundLastDays(3)">Last 3 Days</button> <button type="submit" class="btn btn-xs btn-info" print-remove="" ng-click="fnRefundLastDays(1)">Last 24 Hours</button><table class="table table-striped table-hover" st-table="postings" st-safe-src="data.postings"><thead><tr class="sortable"><th>Date</th><th>Time</th><th>Trans.<br>Type</th><th>Day<br>Receipt</th><th>VRN</th><th>Pump</th><th>Fuel</th><th>CashIn</th><th style="text-align: right;">Dispensed</th><th style="text-align: right;">Refunded</th><th style="text-align: right;">Remain.</th></tr></thead><tbody><tr ng-repeat="item in data.records"><td>{{ item[\'Date\'] }}</td><td>{{ item[\'Time\'] }}</td><td>{{ item[\'Trans. Type\'] }}</td><td>{{ item[\'Day Receipt Id\'] }}</td><td>{{ item[\'VRN\'] }}</td><td>{{ item[\'Pump\'] }}</td><td>{{ item[\'Fuel\'] }}</td><td style="text-align: right;">{{ item[\'CashIn\'] }}</td><td style="text-align: right;">{{ item[\'Dispensed\'] | number:2 }}</td><td style="text-align: right;" bind-html-compile="fnRefundLink(item);"></td><td style="text-align: right;">{{ item[\'Remain.\'] | number:2 }}</td></tr><tr><td colspan="7"></td><td class="totals" style="text-align:right;">{{ getTotal(\'CashIn\') }}</td><td class="totals" style="text-align:right;">{{ getTotal(\'Dispensed\') | number:2 }}</td><td class="totals" style="text-align:right;">{{ getTotal(\'Refunded\') | number:2 }}</td><td class="totals" style="text-align:right;">{{ getTotal(\'Remain.\') | number:2 }}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/pages/sales/tagging/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="titleAttendant" data="data.byAttendand" currencies="[\'Total Dispensed\']" print-section=""></auto-data-table-component><auto-data-table-component heading="titleDetails" data="data.details" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" decimals="{Litres:3, Rate:3}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/tank/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><auto-data-table-component heading="title" data="data.records" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" decimals="{Litres:2,Rate:3}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/pages/sales/total/template.html','<date-time-from-to-component from-date-time="dates.from" to-date-time="dates.to" submit="fnSubmit" default="fnDefault" print-remove=""></date-time-from-to-component><p print-section="">Report from {{ dates.from | date : \'dd MMM yyyy @ h:mma\' }} up to {{ dates.to | date : \'dd MMM yyyy @ h:mma\' }}</p><auto-data-table-component heading="\'by OPT\'" data="data.byOpt" server="optCallServer" currencies="[\'Total\']" totals="[\'Total\', \'Qty\']" paging-enabled="false" print-section=""></auto-data-table-component><auto-data-table-component heading="\'by Sale Type\'" data="data.byType" currencies="[\'CashIn\',\'Dispensed\',\'Refunded\']" decimals="{Litres:2}" totals="[\'CashIn\',\'Dispensed\',\'Refunded\',\'Litres\']" print-section=""></auto-data-table-component><auto-data-table-component heading="\'by Attendant\'" data="data.byAttendand" currencies="[\'Total Dispensed\']" totals="[\'Total Dispensed\']" print-section=""></auto-data-table-component>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title" print-section="">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb" print-remove=""><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>X</span>oil</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><i class="ion-android-person" style="font-size: 48px; padding-left: 5px;"></i></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/change-password">Change Password</a></li><li ng-controller="logoutCtrl"><a href="" class="signout" ng-click="signOut();"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');}]);